import Handsontable from 'handsontable';
import Vue from 'vue';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var version="4.1.0-ec52";

var Utils =
/*#__PURE__*/
function () {
  function Utils() {
    var _this = this;

    _classCallCheck(this, Utils);

    /**
     * 字典表
     */
    this.dicts = {};
    /** 字典表 code 字段 */

    this.dictCodeKey = "value";
    /** 字典表 name 字段 */

    this.dictNameKey = "name";
    /** localStorage */

    this.localStoragePrefix = "HotTable";
    this.config = {};
    /**
     * 获取布局列表的方法
     */

    this.getLayoutSettingsList = function (_ref) {
      var colSettingsKey = _ref.colSettingsKey;
      return _this.axios.get("".concat(_this.listUrl).concat(colSettingsKey), {
        params: {
          unique: new Date().getTime(),
          pathname: _this.pathname
        }
      }).then(function (response) {
        var list = response.data || response.data.data || [];
        list.forEach(function (item) {
          return item.layoutName = item.name;
        });
        return list;
      });
    };
    /**
     * 删除布局的方法
     */


    this.deleteLayoutSettings = function (params) {
      console.log(params);
      return _this.axios.get("".concat(_this.deleteUrl).concat(params.colSettingsKey, "/").concat(params.layoutName), {
        params: {
          pathname: _this.pathname
        }
      }).then(function (response) {
        return response.data;
      });
    };
    /**
     * 保存布局的方法
     */


    this.saveLayoutSettings = function (params) {
      return _this.saveAsLayoutSettings(params);
    };

    this.saveAsLayoutSettings = function (params) {
      console.log("saveAsLayoutSettings");
      console.log(params);
      var postParams = {
        name: params.layoutName,
        pathname: _this.pathname,
        tableId: params.colSettingsKey,
        content: JSON.stringify(_objectSpread2({}, params, {
          version: new Date().getTime()
        }))
      };
      var url = _this.saveAsUrl;
      console.log(url);
      return _this.axios.post(url, postParams).then(function (response) {
        return response.data;
      });
    };
  }
  /**
   * 注册字典表
   * @param dicts
   */


  _createClass(Utils, [{
    key: "registDict",
    value: function registDict(dicts, codeKey, nameKey) {
      utils.dicts = Object.assign({}, utils.dicts, dicts);

      if (codeKey) {
        utils.dictCodeKey = codeKey;
      }

      if (nameKey) {
        utils.dictNameKey = nameKey;
      }
    }
    /**
     * 转换字典表
     * @param dictName
     * @param dictCode
     */

  }, {
    key: "transformDict",
    value: function transformDict(dictName, dictCode) {
      var dicts = this.dicts,
          dictCodeKey = this.dictCodeKey,
          dictNameKey = this.dictNameKey;
      var list = dicts[dictName] || [];
      var item = list.find(function (d) {
        return d[dictCodeKey] == dictCode;
      }) || {};
      return item[dictNameKey] || dictCode;
    }
    /**
     * 设置 localStorage
     * @param key
     * @param value
     */

  }, {
    key: "localStorageSet",
    value: function localStorageSet(key, value) {
      try {
        var str = JSON.stringify(value);
        localStorage.setItem("".concat(this.localStoragePrefix, ".").concat(key), str);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    }
    /**
     * 获取 localStorage
     * @param key
     */

  }, {
    key: "localStorageGet",
    value: function localStorageGet(key) {
      var str = localStorage.getItem("".concat(this.localStoragePrefix, ".").concat(key));

      try {
        var obj = JSON.parse(str);
        return obj;
      } catch (e) {
        console.error(e);
        return str;
      }
    }
  }, {
    key: "localStorageRemove",
    value: function localStorageRemove(key) {
      localStorage.removeItem("".concat(this.localStoragePrefix, ".").concat(key));
    }
    /**
     * 注册方法
     * @param method
     */

  }, {
    key: "registMethod",
    value: function registMethod(methodName, method) {
      this[methodName] = method;
    }
    /**
     * 全局设置注册码
     * @param method
     */

  }, {
    key: "setLicenseKey",
    value: function setLicenseKey(key) {
      this.licenseKey = key;
    }
    /**
     * 获取注册码
     * @param method
     */

  }, {
    key: "getLicenseKey",
    value: function getLicenseKey() {
      return this.licenseKey;
    }
  }, {
    key: "saveLayoutInputValidator",
    value: function saveLayoutInputValidator(input) {
      if (!input || !input.trim()) {
        return "布局名称不能为空。";
      }

      return true;
    }
    /**
     * 获取布局列表的 url
     */

  }, {
    key: "configVal",

    /**
     * 获取配置值
     */
    value: function configVal(key, defaultVal) {
      var config = this.config || {};
      var val = config[key];

      if (val === undefined) {
        val = defaultVal;
      }

      return val;
    }
    /**
     * 获取当前路由路径
     */

  }, {
    key: "listUrl",
    get: function get() {
      var ctx = this.configVal("ctx", "");
      var listUrl = this.configVal("getListUrl", "/layout/list/");
      return "".concat(ctx).concat(listUrl);
    }
    /**
     * 获取删除布局的 url
     */

  }, {
    key: "deleteUrl",
    get: function get() {
      var ctx = this.configVal("ctx", "");
      var deleteUrl = this.configVal("deleteLayoutUrl", "/layout/delete/");
      return "".concat(ctx).concat(deleteUrl);
    }
    /**
     * 获取保存布局的 url
     */

  }, {
    key: "saveAsUrl",
    get: function get() {
      var ctx = this.configVal("ctx", "");
      var createLayoutUrl = this.configVal("createLayoutUrl", "/layout/persist");
      return "".concat(ctx).concat(createLayoutUrl);
    }
  }, {
    key: "pathname",
    get: function get() {
      var pathname = this.route && this.route.fullPath || "";

      if (pathname.indexOf("?") > -1) {
        pathname = pathname.substring(0, pathname.indexOf("?"));
      }

      if (pathname.substring(0, 1) === "/") {
        pathname = pathname.substring(1);
      }

      return pathname;
    }
  }]);

  return Utils;
}();

var utils = new Utils();

var script = {
  props: {
    //isFixedColumn: Boolean, // 是否固定列
    tableLayoutConfig: null
  },
  data: function data() {
    return {
      transferDlgVisible: false,
      // 控制弹窗显隐
      isFixedColumn: true,
      // 是否固定列
      fixedColumnNum: 0,
      //固定列数
      allColumns: [],
      // 所有列
      showColumns: [],
      // 布局的数据源
      groupingColumns: [],
      // 分组数据源
      groupingArrLeft: [],
      groupingArrRight: [],
      ungroupArr: [],
      // 未分组列
      unshowArr: [],
      // 未显示的数据
      selectedShowArrLeft: [],
      // 选中的显示的数组
      selectedGroupArrLeft: [],
      //选中的分组左边的数组
      selectedGroupArrRight: [],
      //选中的分组右边的数组
      layoutData: {},
      // 从表格接收的原始数据
      transferType: "",
      // 穿梭框类型
      transferTitle: [],
      // 标题
      filterTransfer: function filterTransfer(query, item) {
        return item.label.indexOf(query) > -1;
      }
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    /**
     * 重置数据
     */
    resetData: function resetData() {
      this.fixedColumnNum = 0;
      this.selectedShowArrLeft = [];
      this.selectedGroupArrRight = [];
      this.selectedShowArrLeft = [];
      this.layoutData = {};
      this.transferTitle = [];
      this.allColumns = [];
      this.showColumns = [];
      this.groupingColumns = [];
    },
    // 求差,适用于数组对象
    getDiff: function getDiff(param1, param2) {
      var allFieldList = param1.map(function (item) {
        return item["field"];
      });
      var partFieldList = param2.map(function (item) {
        return item["field"];
      });
      var diffFieldList = [];

      for (var i = 0; i < allFieldList.length; i++) {
        if (partFieldList.includes(allFieldList[i])) continue;
        diffFieldList.push(param1[i]);
      }

      return diffFieldList;
    },
    // 匹配列数据
    matchColumns: function matchColumns(arr, columns) {
      var result = arr.map(function (field) {
        return columns.find(function (c) {
          return c.field === field;
        });
      });
      return result;
    },
    // 获取舒数组
    getArray: function getArray(data) {
      var result = data.map(function (item) {
        return item.field;
      });
      return result;
    },
    // 求差集,适合于数组
    subSet: function subSet(arr1, arr2) {
      var set1 = new Set(arr1);
      var set2 = new Set(arr2);

      var subset = _toConsumableArray(new Set(_toConsumableArray(set1).filter(function (item) {
        return !set2.has(item);
      })));

      return subset;
    },

    /**
     * 创建回传到表格的布局数据
     */
    createLayoutData: function createLayoutData(type, layoutName) {
      var unGroupColumns = this.matchColumns(this.ungroupArr, this.allColumns);
      var groupColumns = this.getDiff(this.groupingColumns, unGroupColumns); // 已分组列

      var unvisibleColumns = this.matchColumns(this.unshowArr, this.allColumns); //未显示列

      var visibleColumns = this.getDiff(this.showColumns, unvisibleColumns);
      visibleColumns.unshift.apply(visibleColumns, _toConsumableArray(groupColumns));
      var layoutData = {
        fixedColumnsLeft: parseInt(this.fixedColumnNum) || 0,
        visibleColumns: visibleColumns,
        allColumns: this.layoutData.allColumns,
        groupColumns: groupColumns,
        columnSorting: this.layoutData.columnSorting || [],
        type: type,
        layoutName: layoutName
      };
      return layoutData;
    },
    // 开启弹窗事件
    handleOpenDialog: function handleOpenDialog(data) {
      this.transferDlgVisible = true;
      this.fixedColumnNum = data.fixedColumnsLeft;
      this.layoutData = data;

      if (data.groupColumns === undefined) {
        this.layoutData["groupColumns"] = [];
      }

      this.allColumns = this.layoutData.allColumns; // 布局数据

      var unshowColumns = this.getDiff(this.layoutData.allColumns, this.layoutData.visibleColumns);
      this.unshowArr = this.getArray(unshowColumns);
      this.showColumns = this.getDiff(this.layoutData.allColumns, this.layoutData.groupColumns); // 分组数据

      this.groupingColumns = this.layoutData.visibleColumns; // 未分组数据

      this.ungroupArr = this.getArray(this.getDiff(this.groupingColumns, this.layoutData.groupColumns));
    },
    // 关闭弹窗事件
    handleCloseDialog: function handleCloseDialog() {
      this.transferDlgVisible = false;
      this.resetData();
    },
    // 分组 右侧列表元素变化
    changeGroup: function changeGroup(value, direction, movedKeys) {
      var movedCols = this.matchColumns(movedKeys, this.allColumns);

      if (direction === "left") {
        this.showColumns = this.getDiff(this.showColumns, movedCols);
      } else if (direction === "right") {
        var _this$showColumns;

        (_this$showColumns = this.showColumns).push.apply(_this$showColumns, _toConsumableArray(movedCols));
      }
    },
    //布局 右侧列表元素变化
    changeLayout: function changeLayout(value, direction, movedKeys) {
      var movedCols = this.matchColumns(movedKeys, this.allColumns);

      if (direction === "left") {
        var _this$groupingColumns, _this$ungroupArr;

        (_this$groupingColumns = this.groupingColumns).push.apply(_this$groupingColumns, _toConsumableArray(movedCols));

        (_this$ungroupArr = this.ungroupArr).push.apply(_this$ungroupArr, _toConsumableArray(movedKeys));
      } else if (direction === "right") {
        this.groupingColumns = this.getDiff(this.groupingColumns, movedCols);
        this.ungroupArr = this.subSet(this.ungroupArr, movedKeys);
      }
    },
    // 分组框右checkbox变化
    changeGroupLeft: function changeGroupLeft(val) {
      this.selectedGroupArrLeft = val;
    },
    // 分组框右checkbox变化
    changeGroupRight: function changeGroupRight(val) {
      this.selectedGroupArrRight = val;
    },
    // 布局框左checkbox变化
    changeLayoutLeft: function changeLayoutLeft(val) {
      this.selectedShowArrLeft = val;
      this.selectedGroupArrRight = val;
    },
    // 排序
    handleSortData: function handleSortData(action, type, selectedArr, operateCols, unHandleArr) {
      if (selectedArr.length !== 0) {
        switch (action) {
          //置顶
          case "stickTop":
            var operateArrTop = this.getArray(operateCols);
            var unselectedArrTop = this.subSet(operateArrTop, selectedArr);
            operateCols = [];
            unselectedArrTop.unshift.apply(unselectedArrTop, _toConsumableArray(selectedArr));
            operateArrTop = _toConsumableArray(unselectedArrTop);
            operateCols = this.matchColumns(operateArrTop, this.allColumns);

            if (type === "Group") {
              this.groupingColumns = operateCols;
            } else if (type === "Layout") {
              this.showColumns = operateCols;
            }

            break;
          // 置底

          case "stickBottom":
            var operateArrBottom = this.getArray(operateCols);
            var unselectedArrBottom = this.subSet(operateArrBottom, selectedArr);
            operateCols = [];
            unselectedArrBottom.push.apply(unselectedArrBottom, _toConsumableArray(selectedArr));
            operateArrBottom = _toConsumableArray(unselectedArrBottom);
            operateCols = this.matchColumns(operateArrBottom, this.allColumns);

            if (type === "Group") {
              this.groupingColumns = operateCols;
            } else if (type === "Layout") {
              this.showColumns = operateCols;
            }

            break;
          // 上移一格

          case "upLevel":
            var allUpOperateArr = this.getArray(operateCols);
            var unUpHandleArr = unHandleArr; // 不操作一边的数组

            var upHandleArr = this.subSet(allUpOperateArr, unUpHandleArr); // 操作边的数组

            var upCompare = function upCompare(value1, value2) {
              if (value1 < value2) {
                return -1;
              } else if (value1 > value2) {
                return 1;
              } else {
                return 0;
              }
            };

            var upArrTemp = upHandleArr;
            var upIndex = [];
            selectedArr.map(function (item) {
              upIndex.push(upArrTemp.indexOf(item));
            });
            upIndex.sort(upCompare); // 对选中值的索引降序

            selectedArr = [];
            upIndex.map(function (i) {
              selectedArr.push(upArrTemp[i]);
            });
            selectedArr.map(function (item) {
              upIndex.push(upArrTemp.indexOf(item));
            });
            selectedArr.map(function (item) {
              var index = upArrTemp.indexOf(item);

              if (index !== 0 && !selectedArr.includes(upArrTemp[index - 1])) {
                var _ref = [upArrTemp[index], upArrTemp[index - 1]];
                upArrTemp[index - 1] = _ref[0];
                upArrTemp[index] = _ref[1];
              }

              return upArrTemp;
            });
            upArrTemp.push.apply(upArrTemp, _toConsumableArray(unUpHandleArr));
            operateCols = this.matchColumns(upArrTemp, this.allColumns);

            if (type === "Group") {
              this.groupingColumns = operateCols;
            } else if (type === "Layout") {
              this.showColumns = operateCols;
            }

            break;
          // 下移一格

          case "downLevel":
            var allDownOperateArr = this.getArray(operateCols);
            var unDownHandleArr = unHandleArr;
            var downHandleArr = this.subSet(allDownOperateArr, unDownHandleArr); // 操作边的数组

            var downCompare = function downCompare(value1, value2) {
              if (value1 < value2) {
                return 1;
              } else if (value1 > value2) {
                return -1;
              } else {
                return 0;
              }
            };

            var downArrTemp = downHandleArr;
            var downIndex = [];
            selectedArr.map(function (item) {
              downIndex.push(downArrTemp.indexOf(item));
            });
            downIndex.sort(downCompare); // 对选中值的索引降序

            selectedArr = [];
            downIndex.map(function (i) {
              selectedArr.push(downArrTemp[i]);
            });
            selectedArr.map(function (item) {
              downIndex.push(downArrTemp.indexOf(item));
            });
            selectedArr.map(function (item) {
              var index = downArrTemp.indexOf(item);

              if (index !== downArrTemp.length - 1 && !selectedArr.includes(downArrTemp[index + 1])) {
                var _ref2 = [downArrTemp[index + 1], downArrTemp[index]];
                downArrTemp[index] = _ref2[0];
                downArrTemp[index + 1] = _ref2[1];
              }

              return downArrTemp;
            });
            downArrTemp.push.apply(downArrTemp, _toConsumableArray(unDownHandleArr));
            operateCols = this.matchColumns(downArrTemp, this.allColumns);

            if (type === "Group") {
              this.groupingColumns = operateCols;
            } else if (type === "Layout") {
              this.showColumns = operateCols;
            } // if (direction === "right") this.ungroupArr = unoperateArr;


            break;
        }
      } else {
        this.$message.error("请选择一条数据");
      }
    },
    // 确定按钮
    sumitTransfer: function sumitTransfer() {
      var data = this.createLayoutData("Submit");
      this.layoutData.callback(data);
      this.handleCloseDialog();
    },
    // 布局另存为
    saveAsLayout: function saveAsLayout(isNew) {
      var _this = this;

      var title = isNew ? "布局保存" : "布局另存为";
      this.$prompt("请输入布局名称", title, "布局另存为", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        inputValidator: utils.saveLayoutInputValidator
      }).then(function (_ref3) {
        var value = _ref3.value;

        var layoutData = _this.createLayoutData("SaveAs", value);

        _this.layoutData.callback(layoutData);

        _this.handleCloseDialog();
      })["catch"](function () {
        _this.$message({
          type: "info",
          message: "取消保存"
        });

        _this.handleCloseDialog();
      });
    },
    // 保存布局
    saveLayout: function saveLayout() {
      if (!this.layoutData.currentLayoutName) {
        this.saveAsLayout(true);
      } else {
        var layoutData = this.createLayoutData("Save");
        this.layoutData.callback(layoutData);
        this.handleCloseDialog();
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "transfer-wrap"
  }, [_c('el-dialog', {
    staticStyle: {
      "top": "20px"
    },
    attrs: {
      "width": "880px",
      "append-to-body": "",
      "visible": _vm.transferDlgVisible,
      "before-close": _vm.handleCloseDialog
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.transferDlgVisible = $event;
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v("自定义列表项固定列数：")]), _vm._v(" "), _c('el-input', {
    staticClass: "fixed-col-input",
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.fixedColumnNum,
      callback: function callback($$v) {
        _vm.fixedColumnNum = $$v;
      },
      expression: "fixedColumnNum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "transfer-box"
  }, [_c('el-transfer', {
    staticClass: "transfer-item group-item",
    attrs: {
      "titles": ['已分组', '未分组'],
      "data": _vm.groupingColumns,
      "props": {
        key: 'field',
        label: 'title'
      },
      "filterable": "",
      "fitler-method": _vm.filterTransfer,
      "target-order": "push",
      "left-default-checked": _vm.selectedGroupArrLeft,
      "right-default-checked": _vm.selectedGroupArrRight
    },
    on: {
      "left-check-change": _vm.changeGroupLeft,
      "right-check-change": _vm.changeGroupRight,
      "change": _vm.changeGroup
    },
    model: {
      value: _vm.ungroupArr,
      callback: function callback($$v) {
        _vm.ungroupArr = $$v;
      },
      expression: "ungroupArr"
    }
  }), _vm._v(" "), _c('el-transfer', {
    staticClass: "transfer-item layout-item",
    attrs: {
      "titles": ['已显示', '未显示'],
      "data": _vm.showColumns,
      "props": {
        key: 'field',
        label: 'title'
      },
      "filterable": "",
      "fitler-method": _vm.filterTransfer,
      "target-order": "push"
    },
    on: {
      "left-check-change": _vm.changeLayoutLeft,
      "change": _vm.changeLayout
    },
    model: {
      value: _vm.unshowArr,
      callback: function callback($$v) {
        _vm.unshowArr = $$v;
      },
      expression: "unshowArr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "transfer-icons"
  }, [_c('div', {
    staticClass: "group-icons"
  }, [_c('i', {
    staticClass: "el-icon-upload2",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('stickTop', 'Group', _vm.selectedGroupArrLeft, _vm.groupingColumns);
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-download",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('stickBottom', 'Group', _vm.selectedGroupArrLeft, _vm.groupingColumns);
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-top",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('upLevel', 'Group', _vm.selectedGroupArrLeft, _vm.groupingColumns, _vm.ungroupArr);
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('downLevel', 'Group', _vm.selectedGroupArrLeft, _vm.groupingColumns, _vm.ungroupArr);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-icons"
  }, [_c('i', {
    staticClass: "el-icon-upload2",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('stickTop', 'Layout', _vm.selectedShowArrLeft, _vm.showColumns);
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-download",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('stickBottom', 'Layout', _vm.selectedShowArrLeft, _vm.showColumns);
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-top",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('upLevel', 'Layout', _vm.selectedShowArrLeft, _vm.showColumns, _vm.unshowArr);
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('downLevel', 'Layout', _vm.selectedShowArrLeft, _vm.showColumns, _vm.unshowArr);
      }
    }
  })])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm.layoutData.currentLayoutName ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.saveAsLayout
    }
  }, [_vm._v("布局另存为")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.saveLayout
    }
  }, [_vm._v("保存布局")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.sumitTransfer
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCloseDialog
    }
  }, [_vm._v("取 消")])], 1)])], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-7aede1c0_0", {
    source: ".fixed-col-input{width:65px}.fixed-col-input>.el-input__inner{height:28px}.el-icon-circle-close:before{position:absolute;height:28px;line-height:28px}.transfer-item{display:inline-block}.transfer-item .el-transfer__buttons{padding:0 19px}.group-item>.el-transfer-panel:last-child{display:none}.group-icons{display:inline-block}.layout-icons{display:inline-block;margin-left:250px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

var GroupTableLayoutTransfer = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);

var unassignedPropSymbol = Symbol("unassigned");

var unassignedPropSymbolFunc = function unassignedPropSymbolFunc() {
  return unassignedPropSymbol;
};

var bulkComponentContainer = null;
/**
 * Private method to ensure the table is not calling `updateSettings` after editing cells.
 * @private
 */

function preventInternalEditWatch(component) {
  component.hotInstance.addHook("beforeChange", function () {
    component.__internalEdit = true;
  });
  component.hotInstance.addHook("beforeCreateRow", function () {
    component.__internalEdit = true;
  });
  component.hotInstance.addHook("beforeCreateCol", function () {
    component.__internalEdit = true;
  });
  component.hotInstance.addHook("beforeRemoveRow", function () {
    component.__internalEdit = true;
  });
  component.hotInstance.addHook("beforeRemoveCol", function () {
    component.__internalEdit = true;
  });
}
/**
 * Generate an object containing all the available Handsontable properties and plugin hooks.
 *
 * @param {String} source Source for the factory (either 'HotTable' or 'HotColumn').
 * @returns {Object}
 */

function propFactory(source) {
  var registeredHooks = Handsontable.hooks.getRegistered();
  var propSchema = new Handsontable.DefaultSettings();

  for (var prop in propSchema) {
    propSchema[prop] = {
      "default": unassignedPropSymbolFunc
    };
  }

  for (var i = 0; i < registeredHooks.length; i++) {
    propSchema[registeredHooks[i]] = {
      "default": unassignedPropSymbolFunc
    };
  }

  propSchema.settings = {
    "default": unassignedPropSymbolFunc
  };

  if (source === "HotTable") {
    ["data", "colHeaders"].forEach(function (key) {
      delete propSchema[key];
    });
    propSchema.id = {
      type: String,
      "default": "hot-" + Math.random().toString(36).substring(5)
    };
    propSchema.wrapperRendererCacheSize = {
      type: Number,
      "default": 3000
    };
    propSchema.dataSource = {
      type: [Array, Object],
      "default": function _default() {
        return [];
      }
    };
    propSchema.rules = {
      type: [Array, Object],
      "default": function _default() {
        return null;
      }
    };
    propSchema.rulesKey = {
      type: String
    };
    propSchema.combineName = {
      type: String
    };
    propSchema.colSettingsKey = {
      type: String,
      "default": ""
    };
    propSchema["backEndSortHandle"] = Function; // 配置根据数据合并显示表格列

    propSchema["mergeColumns"] = Boolean;
    propSchema.hasTip = {
      type: [Boolean, String],
      "default": null
    };
    propSchema.emptyText = String;
    propSchema.showFilter = {
      type: Boolean,
      "default": null
    };
    propSchema.showIndexColumn = {
      type: Boolean,
      "default": true
    };
    propSchema.fixedColumnsRight = {
      type: Number,
      "default": 0
    };
    propSchema.showColumnHeaderTip = {
      type: Boolean,
      "default": true
    };
    propSchema.selectionColumnWidth = {
      type: Number,
      "default": 60
    };
    propSchema.selectionColumnTitle = {
      type: String,
      "default": "序号"
    };
    propSchema.sumColumnTitle = {
      type: String,
      "default": "总计"
    };
    propSchema.sumColumnTitleBold = {
      type: Boolean,
      "default": false
    };
    propSchema.css = {
      type: Function
    };
    propSchema.tabIndexKey = {
      type: Object
    };
    propSchema.currentPage = {
      type: Number
    };
    propSchema.pageSize = {
      type: Number
    };
    propSchema.requestCtx = {
      type: String
    };
    propSchema.groupColumns = {
      type: [Array, Object]
    };
    propSchema.autoRowStatus = {
      type: Boolean,
      "default": false
    };
  } else if (source === "HotColumn") {
    propSchema.summary = {
      type: String,
      "default": ""
    };
    propSchema.align = {
      type: String,
      "default": ""
    };
    propSchema.hidden = {
      type: Boolean,
      "default": false
    };
    propSchema.hasTip = {
      type: [Boolean, String],
      "default": null
    };
    propSchema.dictName = {
      type: String,
      "default": null
    };
    propSchema.sortable = {
      type: String,
      "default": null
    };
    propSchema.css = {
      type: Function,
      "default": null
    };
    propSchema.allowInvalid = {
      type: Boolean,
      "default": true
    };
    propSchema.editorName = {
      type: String,
      "default": ""
    };
    propSchema.dateFormat = {
      type: String,
      "default": null
    };
    propSchema.displayFormat = {
      type: Function,
      "default": null
    }; // 配置根据数据合并显示表格列

    propSchema["mergeColumn"] = Boolean;
    propSchema.showFilter = {
      type: Boolean,
      "default": true
    };
    propSchema.calculate = {
      type: Function,
      "default": null
    };
    propSchema.checkedDisplay = {
      type: String
    };
    propSchema.uncheckedDisplay = {
      type: String
    };
    propSchema.required = {
      type: Boolean
    };
    propSchema.showCheckAll = {
      type: Boolean
    };
    propSchema.valueParser = {
      type: Function
    };
    propSchema.maxWidth = {
      type: Number
    };
  }

  return propSchema;
}
/**
 * Filter out all of the unassigned props, and return only the one passed to the component.
 *
 * @param {Object} props Object containing all the possible props.
 * @returns {Object} Object containing only used props.
 */

function filterPassedProps(props) {
  var filteredProps = {};
  var columnSettingsProp = props["settings"];

  if (columnSettingsProp !== unassignedPropSymbol) {
    for (var propName in columnSettingsProp) {
      if (columnSettingsProp.hasOwnProperty(propName) && columnSettingsProp[propName] !== unassignedPropSymbol) {
        filteredProps[propName] = columnSettingsProp[propName];
      }
    }
  }

  for (var _propName in props) {
    if (props.hasOwnProperty(_propName) && _propName !== "settings" && props[_propName] !== unassignedPropSymbol) {
      filteredProps[_propName] = props[_propName];
    }
  }

  return filteredProps;
}
/**
 * Prepare the settings object to be used as the settings for Handsontable, based on the props provided to the component.
 *
 * @param {Object} props The props passed to the component.
 * @returns {Object} An object containing the properties, ready to be used within Handsontable.
 */

function prepareSettings(props) {
  var assignedProps = filterPassedProps(props);
  var hotSettingsInProps = props.settings ? props.settings : assignedProps;
  var additionalHotSettingsInProps = props.settings ? assignedProps : null;
  var newSettings = {};

  for (var key in hotSettingsInProps) {
    if (hotSettingsInProps.hasOwnProperty(key) && hotSettingsInProps[key] !== void 0 && key !== "hiddenColumns") {
      newSettings[key] = hotSettingsInProps[key];
    }
  }

  for (var _key in additionalHotSettingsInProps) {
    if (_key !== "id" && _key !== "settings" && _key !== "wrapperRendererCacheSize" && _key !== "hiddenColumns" && additionalHotSettingsInProps.hasOwnProperty(_key) && additionalHotSettingsInProps[_key] !== void 0) {
      newSettings[_key] = additionalHotSettingsInProps[_key];
    }
  }

  return newSettings;
}
/**
 * Get the VNode element with the provided type attribute from the component slots.
 *
 * @param {Array} componentSlots Array of slots from a component.
 * @param {String} type Type of the child component. Either `hot-renderer` or `hot-editor`.
 * @returns {Object|null} The VNode of the child component (or `null` when nothing's found).
 */

function findVNodeByType(componentSlots, type) {
  var componentVNode = null;
  componentSlots.every(function (slot, index) {
    if (slot.data && slot.data.attrs && slot.data.attrs[type] !== void 0) {
      componentVNode = slot;
      return false;
    }

    return true;
  });
  return componentVNode;
}
/**
 * Get all `hot-column` component instances from the provided children array.
 *
 * @param {Array} children Array of children from a component.
 * @returns {Array} Array of `hot-column` instances.
 */

function getHotColumnComponents(children) {
  var result = [];
  forChildren(children);
  return result;

  function forChildren() {
    var _children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _children.forEach(function (c) {
      if (c.$options.name === "HotColumn") {
        result.push(c);
        return;
      }

      if (c.$options.name === "HotNestedHeader") {
        forChildren(c.$children);
      }
    });
  }
}
/**
 * Create an instance of the Vue Component based on the provided VNode.
 *
 * @param {Object} vNode VNode element to be turned into a component instance.
 * @param {Object} parent Instance of the component to be marked as a parent of the newly created instance.
 * @param {Object} props Props to be passed to the new instance.
 * @param {Object} data Data to be passed to the new instance.
 */

function createVueComponent(vNode, parent, props, data) {
  var ownerDocument = parent.$el ? parent.$el.ownerDocument : document;
  var listeners;

  if (vNode.data && vNode.data.attrs.hasOwnProperty("hot-editor") || data && data["isRenderer"]) {
    var key;

    for (key in vNode.data.attrs) {
      if (key === "hot-editor") continue;
      props[key] = vNode.data.attrs[key];
    }

    for (key in vNode.componentOptions.propsData) {
      props[key] = vNode.componentOptions.propsData[key];
    }

    listeners = vNode.componentOptions.listeners;
  }

  var settings = {
    propsData: props,
    parent: parent,
    data: data
  };

  if (listeners) {
    settings["_parentListeners"] = listeners;
  }

  if (!bulkComponentContainer) {
    bulkComponentContainer = ownerDocument.createElement("DIV");
    bulkComponentContainer.id = "vueHotComponents";
    ownerDocument.body.appendChild(bulkComponentContainer);
  } // 传入插槽


  settings["_renderChildren"] = vNode.componentOptions.children;
  var componentContainer = ownerDocument.createElement("DIV");
  bulkComponentContainer.appendChild(componentContainer);
  var component = new vNode.componentOptions.Ctor(settings);
  return component.$mount(componentContainer);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var lru = createCommonjsModule(function (module, exports) {
  /**
   * A doubly linked list-based Least Recently Used (LRU) cache. Will keep most
   * recently used items while discarding least recently used items when its limit
   * is reached.
   *
   * Licensed under MIT. Copyright (c) 2010 Rasmus Andersson <http://hunch.se/>
   * See README.md for details.
   *
   * Illustration of the design:
   *
   *       entry             entry             entry             entry
   *       ______            ______            ______            ______
   *      | head |.newer => |      |.newer => |      |.newer => | tail |
   *      |  A   |          |  B   |          |  C   |          |  D   |
   *      |______| <= older.|______| <= older.|______| <= older.|______|
   *
   *  removed  <--  <--  <--  <--  <--  <--  <--  <--  <--  <--  <--  added
   */
  (function (g, f) {
    var e =  exports ;
    f(e);
  })(commonjsGlobal, function (exports) {
    var NEWER = Symbol('newer');
    var OLDER = Symbol('older');

    function LRUMap(limit, entries) {
      if (typeof limit !== 'number') {
        // called as (entries)
        entries = limit;
        limit = 0;
      }

      this.size = 0;
      this.limit = limit;
      this.oldest = this.newest = undefined;
      this._keymap = new Map();

      if (entries) {
        this.assign(entries);

        if (limit < 1) {
          this.limit = this.size;
        }
      }
    }

    exports.LRUMap = LRUMap;

    function Entry(key, value) {
      this.key = key;
      this.value = value;
      this[NEWER] = undefined;
      this[OLDER] = undefined;
    }

    LRUMap.prototype._markEntryAsUsed = function (entry) {
      if (entry === this.newest) {
        // Already the most recenlty used entry, so no need to update the list
        return;
      } // HEAD--------------TAIL
      //   <.older   .newer>
      //  <--- add direction --
      //   A  B  C  <D>  E


      if (entry[NEWER]) {
        if (entry === this.oldest) {
          this.oldest = entry[NEWER];
        }

        entry[NEWER][OLDER] = entry[OLDER]; // C <-- E.
      }

      if (entry[OLDER]) {
        entry[OLDER][NEWER] = entry[NEWER]; // C. --> E
      }

      entry[NEWER] = undefined; // D --x

      entry[OLDER] = this.newest; // D. --> E

      if (this.newest) {
        this.newest[NEWER] = entry; // E. <-- D
      }

      this.newest = entry;
    };

    LRUMap.prototype.assign = function (entries) {
      var entry,
          limit = this.limit || Number.MAX_VALUE;

      this._keymap.clear();

      var it = entries[Symbol.iterator]();

      for (var itv = it.next(); !itv.done; itv = it.next()) {
        var e = new Entry(itv.value[0], itv.value[1]);

        this._keymap.set(e.key, e);

        if (!entry) {
          this.oldest = e;
        } else {
          entry[NEWER] = e;
          e[OLDER] = entry;
        }

        entry = e;

        if (limit-- == 0) {
          throw new Error('overflow');
        }
      }

      this.newest = entry;
      this.size = this._keymap.size;
    };

    LRUMap.prototype.get = function (key) {
      // First, find our cache entry
      var entry = this._keymap.get(key);

      if (!entry) return; // Not cached. Sorry.
      // As <key> was found in the cache, register it as being requested recently

      this._markEntryAsUsed(entry);

      return entry.value;
    };

    LRUMap.prototype.set = function (key, value) {
      var entry = this._keymap.get(key);

      if (entry) {
        // update existing
        entry.value = value;

        this._markEntryAsUsed(entry);

        return this;
      } // new entry


      this._keymap.set(key, entry = new Entry(key, value));

      if (this.newest) {
        // link previous tail to the new tail (entry)
        this.newest[NEWER] = entry;
        entry[OLDER] = this.newest;
      } else {
        // we're first in -- yay
        this.oldest = entry;
      } // add new entry to the end of the linked list -- it's now the freshest entry.


      this.newest = entry;
      ++this.size;

      if (this.size > this.limit) {
        // we hit the limit -- remove the head
        this.shift();
      }

      return this;
    };

    LRUMap.prototype.shift = function () {
      // todo: handle special case when limit == 1
      var entry = this.oldest;

      if (entry) {
        if (this.oldest[NEWER]) {
          // advance the list
          this.oldest = this.oldest[NEWER];
          this.oldest[OLDER] = undefined;
        } else {
          // the cache is exhausted
          this.oldest = undefined;
          this.newest = undefined;
        } // Remove last strong reference to <entry> and remove links from the purged
        // entry being returned:


        entry[NEWER] = entry[OLDER] = undefined;

        this._keymap["delete"](entry.key);

        --this.size;
        return [entry.key, entry.value];
      }
    }; // ----------------------------------------------------------------------------
    // Following code is optional and can be removed without breaking the core
    // functionality.


    LRUMap.prototype.has = function (key) {
      return this._keymap.has(key);
    };
  });
});
var lru_1 = lru.LRUMap;

var script$1 = {
  props: {
    //isFixedColumn: Boolean, // 是否固定列
    tableLayoutConfig: null,
    frosTransferDialogClass: null //剪切列弹框class名称

  },
  data: function data() {
    return {
      cutColDlgVisible: false,
      // 控制弹窗显隐
      isFixedColumn: true,
      // 是否固定列
      fixedColumnNum: 0,
      //固定列数
      transferData: [],
      // 穿梭框数据源
      visibleColumns: [],
      //已显示列
      unvisibleColumns: [],
      // 未显示列
      visibleArr: [],
      // 已显示列数组
      unvisibleArr: [],
      // 未显示列数组
      allArr: [],
      // 所有列的值
      selectedData: [],
      // 已显示列选中的值
      layoutData: {},
      // 从表格接收的原始数据
      filterTransfer: function filterTransfer(query, item) {
        return item.label.indexOf(query) > -1;
      },
      renderContent: function renderContent(h, option) {
        return h('span', {
          attrs: {
            id: option.field
          },
          domProps: {
            innerHTML: option.title
          }
        });
      }
    };
  },
  computed: {},
  watch: {},
  mounted: function mounted() {},
  methods: {
    /**
     * 重置数据
     */
    resetData: function resetData() {
      this.fixedColumnNum = 0;
      this.transferData = [];
      this.showData = [];
      this.selectedData = [];
      this.layoutData = {};
    },

    /**
     * 创建回传到表格的布局数据
     */
    createLayoutData: function createLayoutData(type, layoutName) {
      var visibleColumns = this.matchColumns(this.visibleArr, this.transferData);
      var layoutData = {
        fixedColumnsLeft: parseInt(this.fixedColumnNum) || 0,
        // visibleColumns: (this.showData || []).map(field => {
        //   return (
        //     (this.layoutData.visibleColumns || []).find(
        //       c => c.field === field
        //     ) || (this.layoutData.allColumns || []).find(c => c.field === field)
        //   );
        // }),
        visibleColumns: visibleColumns,
        columnSorting: this.layoutData.columnSorting || [],
        type: type,
        layoutName: layoutName
      };
      return layoutData;
    },
    // 右侧值checkbox变化
    // changeRight(val) {
    //   this.selectedData = val;
    // },
    changeLeft: function changeLeft(val) {
      this.selectedData = val;
    },
    // 右侧列表元素变化时触发
    handleChange: function handleChange(value, direction, movedKeys) {
      this.visibleArr = this.subSet(this.allArr, value);
    },
    // 确定按钮
    sumitTransfer: function sumitTransfer() {
      var data = this.createLayoutData('Submit');
      this.layoutData.callback(data);
      this.handleCloseDialog();
    },
    // 取消按钮
    handleCloseDialog: function handleCloseDialog() {
      this.cutColDlgVisible = false;
      this.resetData();
    },
    handleOpenDialog: function handleOpenDialog(val) {
      this.cutColDlgVisible = true;
      this.layoutData = val;
      this.visibleColumns = val.visibleColumns;
      this.visibleArr = val.visibleColumns.map(function (c) {
        return c.field;
      });
      this.unvisibleColumns = this.getDiff(val.allColumns, val.visibleColumns);
      this.unvisibleArr = this.unvisibleColumns.map(function (c) {
        return c.field;
      });
      this.fixedColumnNum = val.fixedColumnsLeft;
      this.allArr = val.allColumns.map(function (c) {
        return c.field;
      });
      this.transferData = val.allColumns;
    },
    // 求差集
    subSet: function subSet(arr1, arr2) {
      var set1 = new Set(arr1);
      var set2 = new Set(arr2);

      var subset = _toConsumableArray(new Set(_toConsumableArray(set1).filter(function (item) {
        return !set2.has(item);
      })));

      return subset;
    },
    // 求差,适用于数组对象
    getDiff: function getDiff(param1, param2) {
      var allFieldList = param1.map(function (item) {
        return item['field'];
      });
      var partFieldList = param2.map(function (item) {
        return item['field'];
      });
      var diffFieldList = [];

      for (var i = 0; i < allFieldList.length; i++) {
        if (partFieldList.includes(allFieldList[i])) continue;
        diffFieldList.push(param1[i]);
      }

      return diffFieldList;
    },
    // 匹配列数据
    matchColumns: function matchColumns(arr, columns) {
      var result = (arr || []).map(function (field) {
        return columns.find(function (c) {
          return c.field === field;
        });
      });
      return result;
    },
    // 获取数组
    getArray: function getArray(data) {
      var result = data.map(function (item) {
        return item.field;
      });
      return result;
    },
    // 排序
    handleSortData: function handleSortData(action) {
      var _this = this;

      if (this.selectedData.length !== 0) {
        switch (action) {
          //置顶
          case 'stickTop':
            var topVisibleArr = this.subSet(this.allArr, this.unvisibleArr);
            var topSet = this.subSet(topVisibleArr, this.selectedData);
            topSet.unshift.apply(topSet, _toConsumableArray(this.selectedData));
            this.visibleArr = topSet;
            this.allArr = topSet.concat(this.unvisibleArr);
            this.transferData = this.matchColumns(this.allArr, this.transferData); // let topSet = this.subSet(this.visibleArr, this.selectedData); // 求出差集
            // topSet.unshift(...this.selectedData);
            // this.showData = [...topSet];

            break;
          // 置底

          case 'stickBottom':
            // let bottomSet = this.subSet(this.visibleArr, this.selectedData);
            // bottomSet.push(...this.selectedData);
            // this.showData = [...bottomSet];
            var bottomVisibleArr = this.subSet(this.allArr, this.unvisibleArr);
            var bottomSet = this.subSet(bottomVisibleArr, this.selectedData);
            bottomSet.push.apply(bottomSet, _toConsumableArray(this.selectedData));
            this.visibleArr = bottomSet;
            this.allArr = bottomSet.concat(this.unvisibleArr);
            this.transferData = this.matchColumns(this.allArr, this.transferData);
            break;
          // 上移一格

          case 'upLevel':
            var upCompare = function upCompare(value1, value2) {
              if (value1 < value2) {
                return -1;
              } else if (value1 > value2) {
                return 1;
              } else {
                return 0;
              }
            };

            var upTemp = this.visibleArr;
            this.visibleArr = [];
            var upIndex = [];
            this.selectedData.map(function (item) {
              upIndex.push(upTemp.indexOf(item));
            });
            upIndex.sort(upCompare); // 对选中值的索引升序

            this.selectedData = [];
            upIndex.map(function (i) {
              _this.selectedData.push(upTemp[i]);
            });
            this.selectedData.map(function (item) {
              var index = upTemp.indexOf(item);

              if (index !== 0 && !_this.selectedData.includes(upTemp[index - 1])) {
                var _ref = [upTemp[index], upTemp[index - 1]];
                upTemp[index - 1] = _ref[0];
                upTemp[index] = _ref[1];
              }

              return upTemp;
            });
            this.visibleArr = upTemp;
            this.allArr = upTemp.concat(this.unvisibleArr);
            this.transferData = this.matchColumns(this.allArr, this.transferData);
            break;
          // 下移一格

          case 'downLevel':
            var downCompare = function downCompare(value1, value2) {
              if (value1 < value2) {
                return 1;
              } else if (value1 > value2) {
                return -1;
              } else {
                return 0;
              }
            };

            var downTemp = this.visibleArr;
            this.visibleArr = [];
            var downIndex = [];
            this.selectedData.map(function (item) {
              downIndex.push(downTemp.indexOf(item));
            });
            downIndex.sort(downCompare); // 对选中值的索引降序

            this.selectedData = [];
            downIndex.map(function (i) {
              _this.selectedData.push(downTemp[i]);
            });
            this.selectedData.map(function (item) {
              downIndex.push(downTemp.indexOf(item));
            });
            this.selectedData.map(function (item) {
              var index = downTemp.indexOf(item);

              if (index !== downTemp.length - 1 && !_this.selectedData.includes(downTemp[index + 1])) {
                var _ref2 = [downTemp[index + 1], downTemp[index]];
                downTemp[index] = _ref2[0];
                downTemp[index + 1] = _ref2[1];
              }

              return downTemp;
            });
            this.visibleArr = downTemp;
            this.allArr = downTemp.concat(this.unvisibleArr);
            this.transferData = this.matchColumns(this.allArr, this.transferData);
            break;
        }
      } else {
        this.$message.error('请选择一条数据');
      }
    },
    // 布局另存为
    saveAsLayout: function saveAsLayout(isNew) {
      var _this2 = this;

      var title = isNew ? '布局保存' : '布局另存为';
      this.$prompt('请输入布局名称', title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: utils.saveLayoutInputValidator
      }).then(function (_ref3) {
        var value = _ref3.value;

        var layoutData = _this2.createLayoutData('SaveAs', value);

        _this2.layoutData.callback(layoutData);

        _this2.handleCloseDialog();
      })["catch"](function () {
        _this2.$message({
          type: 'info',
          message: '取消保存'
        });

        _this2.handleCloseDialog();
      });
    },
    // 保存布局
    saveLayout: function saveLayout() {
      if (!this.layoutData.currentLayoutName) {
        this.saveAsLayout(true);
      } else {
        var layoutData = this.createLayoutData('Save');
        this.layoutData.callback(layoutData);
        this.handleCloseDialog();
      }
    }
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "transfer-wrap"
  }, [_c('el-dialog', {
    "class": _vm.frosTransferDialogClass,
    staticStyle: {
      "top": "20px"
    },
    attrs: {
      "width": "650px",
      "visible": _vm.cutColDlgVisible,
      "before-close": _vm.handleCloseDialog
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.cutColDlgVisible = $event;
      }
    }
  }, [_vm.isFixedColumn ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v("自定义列表项固定列数：")]), _vm._v(" "), _c('el-input', {
    staticClass: "fixed-col-input",
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.fixedColumnNum,
      callback: function callback($$v) {
        _vm.fixedColumnNum = $$v;
      },
      expression: "fixedColumnNum"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "transfer-box"
  }, [_c('el-transfer', {
    attrs: {
      "titles": ['已显示列', '未显示列'],
      "data": _vm.transferData,
      "props": {
        key: 'field',
        label: 'title'
      },
      "filterable": "",
      "fitler-method": _vm.filterTransfer,
      "render-content": _vm.renderContent,
      "target-order": "push"
    },
    on: {
      "left-check-change": _vm.changeLeft,
      "change": _vm.handleChange
    },
    model: {
      value: _vm.unvisibleArr,
      callback: function callback($$v) {
        _vm.unvisibleArr = $$v;
      },
      expression: "unvisibleArr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "transfer-icons"
  }, [_c('i', {
    staticClass: "el-icon-upload2",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('stickTop');
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-download",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('stickBottom');
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-top",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('upLevel');
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    on: {
      "click": function click($event) {
        return _vm.handleSortData('downLevel');
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm.layoutData.currentLayoutName ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.saveAsLayout
    }
  }, [_vm._v("布局另存为\n      ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.saveLayout
    }
  }, [_vm._v("保存布局")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.sumitTransfer
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCloseDialog
    }
  }, [_vm._v("取 消")])], 1)])], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-11cf3dee_0", {
    source: ".fixed-col-input{width:65px}.fixed-col-input>.el-input__inner{height:28px}.el-icon-circle-close:before{position:absolute;height:28px;line-height:28px}.transfer-icons{height:40px;line-height:40px;padding-right:5px}.handsontable .el-transfer{display:flex;justify-content:space-between;align-items:center}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject SSR */

var TableLayoutTransfer = normalizeComponent_1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, browser, undefined);

var summaryTypeList = ["max", "min", "sum", "average", "count"];
var CHECK_COLUMN_NAME = "$$checked";
var SUMMARY_ROW_FLAG_NAME = "__SUMMARY_ROW"; // 合计

var GROUP_RECORD_FLAG_NAME = "$$groupRow";
var GROUP_RECORD_FIELD_FLAG_NAME = "$$groupField";
var CHILDREN_RECORD_NAME = "__children";
var defaultSettings = {
  rowHeaders: true,
  language: "zh-CN",
  manualColumnMove: true,
  selectionMode: "single",
  stretchH: "last",
  licenseKey: "non-commercial-and-evaluation",
  securityCode: "WjJsc2JHbHZiZz09",
  autoRowSize: false,
  wordWrap: false,
  outsideClickDeselects: false,
  fillHandle: false,
  rowHeights: 24,
  manualColumnResize: true,
  currentRowClassName: "ht-active-row"
};
var SORT_DIRECTION = {
  ASC: "asc",
  DESC: "desc"
};
window["Handsontable"] = Handsontable;
var HotTable = {
  name: "HotTable",
  props: propFactory("HotTable"),
  provide: function provide() {
    return {
      $hotTable: this
    };
  },
  watch: {
    mergedHotSettings: function mergedHotSettings(value) {
      this.hotInstance.updateSettings(value);
    },
    dataSource: function dataSource(value) {
      this.renderData(value);

      if (!this.hotEmptyTextContainer) {
        return;
      }

      if (value && value.length) {
        this.hotEmptyTextContainer.style.display = "none";
      } else {
        this.hotEmptyTextContainer.style.display = "block";
      }
    },
    groupedRules: function groupedRules() {
      this.updateColumnValidator();
    }
  },
  data: function data() {
    var rendererCache = new lru_1(this.wrapperRendererCacheSize); // Make the LRU cache destroy each removed component

    rendererCache.shift = function () {
      var entry = lru_1.prototype.shift.call(this);
      entry[1].component.$destroy();
      return entry;
    };

    var validationGroup;
    var component = this;

    while (component && !validationGroup) {
      var parent = component.$parent;

      if (parent && parent.isValidationGroup) {
        validationGroup = parent;
      } else {
        component = parent;
      }
    }

    return {
      __internalEdit: false,
      hotInstance: null,
      columnSettings: null,
      rendererCache: rendererCache,
      editorCache: new Map(),
      hasSummary: false,
      summaryRowData: false,
      finalData: [],
      summaryData: null,
      summaryPosition: "last",
      showSelection: true,
      frontEndSort: true,
      sortNames: [],
      sortDirections: [],
      hotSettings: {},
      treeView: false,
      groupView: false,
      renderColumns: false,
      layoutSettingsList: [],
      currentLayoutName: null,
      currentLayout: null,
      formData: {},
      error: {},
      errorMessageEl: false,
      dragCheck: false,
      dragStartRow: undefined,
      nestedSettings: false,
      nestedDepth: 0,
      // HotColumn 是否有配置 mergeCell
      hasMergeColumn: false,
      mergeColumnInfo: {},
      dynamicColumnsSettings: null,
      dynamicColumnsLoaded: false,
      ecRules: null,
      validationGroup: validationGroup,
      hotEmptyTextContainer: null,
      offResizeListener: null,
      offScrollListener: null,
      hasCalculate: false,
      destroyHandlers: [],
      keepEditing: false,
      $transformColumns: [],
      defaultHiddenColumns: [],
      allowColumnSorting: []
    };
  },
  computed: {
    mergedHotSettings: function mergedHotSettings() {
      return prepareSettings(this.$props);
    },
    needMergeColumns: function needMergeColumns() {
      return this.mergeColumns || this.hasMergeColumn;
    },

    /** 把规则分组 */
    groupedRules: function groupedRules() {
      var _this2 = this;

      var rules = this.ecRules || this.rules;
      var result = {};

      if (!(rules && rules.length)) {
        return result;
      }

      rules = rules.filter(function (rule) {
        return _this2.combineName ? _this2.combineName === rule.combineName : !rule.combineName;
      });
      rules.forEach(function (rule) {
        var properties = [].concat(_toConsumableArray(rule.property ? [rule.property] : []), _toConsumableArray(rule.properties || []), _toConsumableArray(rule.listenProperties || []));
        properties.forEach(function (p) {
          result[p] = result[p] || [];

          if (result[p].indexOf(rule) < 0) {
            result[p].push(rule);
          }
        });
      });
      return result;
    }
  },
  methods: {
    /**
     * Initialize Handsontable.
     */
    hotInit: function hotInit() {
      var _this3 = this;

      var _this = this;

      var globalRendererVNode = this.getGlobalRendererVNode();
      var globalEditorVNode = this.getGlobalEditorVNode();
      var newSettings = prepareSettings(this.$props);
      var hiddenColumns = [];
      newSettings.columns = this.columnSettings ? this.columnSettings : newSettings.columns;
      if (!newSettings.columns) newSettings.columns = [];

      if (newSettings["treeView"] === true || newSettings["groupView"] === true) {
        newSettings.nestedRows = true;
        this.groupView = newSettings["groupView"] === true;
        this.treeView = newSettings["treeView"] === true;
        if (this.groupView) this.treeView = false;
      }

      if (newSettings["summaryData"]) this.summaryData = newSettings["summaryData"];
      if (newSettings["summaryPosition"]) this.summaryPosition = newSettings["summaryPosition"];
      if (newSettings.hasOwnProperty("showSelection")) this.showSelection = !!newSettings["showSelection"];
      if (newSettings.hasOwnProperty("dragCheck")) this.dragCheck = !!newSettings["dragCheck"];
      if (newSettings["allowColumnSorting"]) this.allowColumnSorting = newSettings["allowColumnSorting"];
      delete newSettings["summaryData"];
      delete newSettings["summaryPosition"]; // delete newSettings['showSelection'];

      delete newSettings["dragCheck"];
      delete newSettings["allowColumnSorting"];
      this.buildColumns(newSettings, hiddenColumns);

      if (this.hiddenColumns && this.hiddenColumns.columns && this.hiddenColumns.columns.length) {
        var _hiddenColumns;

        (_hiddenColumns = hiddenColumns).push.apply(_hiddenColumns, _toConsumableArray(this.hiddenColumns.columns));
      }

      if (this.settings && this.settings.hiddenColumns && this.settings.hiddenColumns.columns && this.settings.hiddenColumns.columns.length) {
        var _hiddenColumns2;

        (_hiddenColumns2 = hiddenColumns).push.apply(_hiddenColumns2, _toConsumableArray(this.settings.hiddenColumns.columns));
      }

      if (this.nestedSettings) {
        newSettings.nestedHeaders = this.nestedSettings;

        if (newSettings.columns[0] && newSettings.columns[0].data === "$$checked") {
          newSettings.nestedHeaders.forEach(function (arr) {
            return arr.unshift("");
          });
        }
      }

      if (globalEditorVNode) {
        newSettings.editor = this.getEditorClass(globalEditorVNode, this);
        globalEditorVNode.child.$destroy();
      }

      if (globalRendererVNode) {
        newSettings.renderer = this.getRendererWrapper(globalRendererVNode, this);
        globalRendererVNode.child.$destroy();
      }

      if (Array.isArray(newSettings.columns) && newSettings.columns.length > 0) {
        var columnSummary = [];

        if (this.summaryData) {
          this.hasSummary = true;
          newSettings.columns.forEach(function (column, i) {
            if (column.data === CHECK_COLUMN_NAME) return;
            columnSummary.push({
              destinationRow: 0,
              destinationColumn: i,
              reversedRowCoords: _this3.summaryPosition !== "first",
              type: "custom",
              customFunction: function customFunction(endpoint) {
                if (!_this3.summaryRowData || _typeof(_this3.summaryRowData) !== "object") return "";
                var columnIndex = endpoint.destinationColumn;

                var prop = _this3.hotInstance.colToProp(columnIndex);

                return _this3.summaryRowData[prop];
              }
            });
          });
        } else {
          this.hasSummary = newSettings.columns.filter(function (column) {
            return column.summary && summaryTypeList.includes(column.summary);
          }).length > 0;

          if (this.hasSummary) {
            newSettings.columns.forEach(function (column, i) {
              if (column.data === CHECK_COLUMN_NAME || !column.summary || !summaryTypeList.includes(column.summary)) return;
              columnSummary.push({
                destinationRow: 0,
                destinationColumn: i,
                reversedRowCoords: _this3.summaryPosition !== "first",
                type: column.summary,
                forceNumeric: true
              });
            });
          }
        }

        if (this.hasSummary) {
          newSettings.columnSummary = function () {
            if (_this3.finalData.length === 0) return [];
            return columnSummary;
          };
        }
      }

      newSettings.colHeaders = function (col) {
        if (_this3.showSelection && col === 0) {
          var txt = '<input type="checkbox" class="ht-check-all" ';
          txt += _this3.isSelectAll() ? 'checked="checked"' : "";
          txt += "/>";
          return txt;
        } else if (col >= 0) {
          var column = _this3.getColumnSettingAtCol(col);

          if (!column) {
            return "";
          }

          if (column.type === "checkbox" && column.showCheckAll) {
            var _requiredClass = column.required ? "ht-column-required" : "";

            var _txt2 = "";
            _txt2 += '<span class="ht-column-title-text' + (_this3.allowColumnSorting.indexOf(column.data) > -1 ? "columnSortingHover" : "") + _requiredClass + '" title="' + (_this3.showColumnHeaderTip ? column.text : "") + '">' + column.text + "</span>";
            _txt2 += '<input type="checkbox"  class="hc-check-all" style="position:relative;left:10px;top:2px"';
            _txt2 += _this3.isColunmSelectAll(col) ? 'checked="checked"' : "";
            _txt2 += "/>";
            return _txt2;
          }

          var _txt = "";

          if (column.sortable === "true") {
            var index = _this3.sortNames.indexOf(column.data);

            var sortDirection = index > -1 ? _this3.sortDirections[index] : "";
            _txt += '<span class="caret-wrapper">';
            _txt += '<i class="sort-caret ascending' + (sortDirection === SORT_DIRECTION.ASC ? " selected" : "") + '"></i>';
            _txt += '<i class="sort-caret descending' + (sortDirection === SORT_DIRECTION.DESC ? " selected" : "") + '"></i>';

            if (_this3.sortNames.length > 1 && index > -1) {
              _txt += "<sub>" + (index + 1) + "</sub>";
            }

            _txt += "</span>";
          }

          var requiredClass = column.required ? "ht-column-required" : "";
          _txt += '<span class="ht-column-title-text ' + (_this3.allowColumnSorting.indexOf(column.data) > -1 ? "columnSortingHover" : "") + requiredClass + '" title="' + (_this3.showColumnHeaderTip ? column.text : "") + '">' + column.text + "</span>";

          if (newSettings["colSettingsKey"] && newSettings["layoutIconVisible"] !== false) {
            var firstColumnIndex = _this3.showSelection ? 1 : 0;

            if (col == firstColumnIndex) {
              _txt += '<i class="el-icon-s-tools hot-layout-settings-button"></i>';
            }
          }

          return _txt;
        } else {
          return "";
        }
      };

      for (var key in defaultSettings) {
        if (!newSettings.hasOwnProperty(key)) newSettings[key] = defaultSettings[key];
      }

      if (utils.getLicenseKey()) {
        newSettings["licenseKey"] = utils.getLicenseKey();
      }

      var width = newSettings["width"] ? parseInt(newSettings["width"].toString()) : 0,
          height = newSettings["height"] ? parseInt(newSettings["height"].toString()) : 0,
          minWidth = newSettings["minWidth"] ? parseInt(newSettings["minWidth"]) : 100,
          minHeight = newSettings["minHeight"] ? parseInt(newSettings["minHeight"]) : 100,
          scrollAutoHeight = newSettings["scrollAutoHeight"] || false;
      var autoResize = {
        width: false,
        height: false
      };

      if (width > 0) {
        newSettings.width = width;
      } else if (this.$el.parentElement.clientWidth > minWidth) {
        newSettings.width = this.getFinalWidth(this.$el.parentElement);
        autoResize.width = true; // this.$nextTick(() => {
        //   newSettings.width = this.getFinalWidth(this.$el.parentElement);
        // });
      } else {
        newSettings.width = minWidth;
      }

      if (height > 0) {
        newSettings.height = height;
      } else if (this.$el.parentElement.clientHeight > minHeight) {
        newSettings.height = this.getFinalHeight(this.$el.parentElement);
        autoResize.height = true; // this.$nextTick(() => {
        //   newSettings.height = this.getFinalHeight(this.$el.parentElement);
        // });
      } else {
        newSettings.height = minHeight;
      }

      if (scrollAutoHeight) {
        newSettings["originalHeight"] = height;
      }

      newSettings.data = [];

      if (newSettings["colSettingsKey"]) {
        // 添加右键菜单
        newSettings.contextMenu = {
          items: {
            separator: Handsontable.plugins.ContextMenu["SEPARATOR"],
            defaultLayout: {
              name: '<span class="el-icon-check hot-context-icon"></span>默认布局',
              callback: function callback() {
                _this.resetLayout();
              }
            },
            separator2: Handsontable.plugins.ContextMenu["SEPARATOR"],
            saveLayout: {
              name: '<span class="el-icon-upload hot-context-icon"></span>保存布局',
              callback: function callback() {
                var _this$getCurrentLayou = _this.getCurrentLayoutInfo(),
                    visibleColumns = _this$getCurrentLayou.visibleColumns,
                    columnSorting = _this$getCurrentLayou.columnSorting,
                    fixedColumnsLeft = _this$getCurrentLayou.fixedColumnsLeft,
                    colSettingsKey = _this$getCurrentLayou.colSettingsKey,
                    groupColumns = _this$getCurrentLayou.groupColumns;

                var currentLayoutName = _this.currentLayoutName,
                    layoutSettingsList = _this.layoutSettingsList;
                var currentLayoutSetting = layoutSettingsList.find(function (s) {
                  return s.layoutName === currentLayoutName;
                });

                if (!currentLayoutSetting) {
                  return;
                }

                _this.saveLayout({
                  visibleColumns: visibleColumns,
                  columnSorting: columnSorting,
                  fixedColumnsLeft: _this.showSelection ? fixedColumnsLeft - 1 : fixedColumnsLeft,
                  colSettingsKey: colSettingsKey,
                  layoutName: currentLayoutSetting.layoutName,
                  gridLayoutId: currentLayoutSetting.gridLayoutId,
                  groupColumns: groupColumns
                });
              },
              hidden: function hidden() {
                return !_this.currentLayoutName;
              }
            },
            saveAsLayout: {
              name: '<span class="el-icon-circle-plus hot-context-icon"></span>布局另存为...',
              callback: function callback() {
                _this.$prompt("请输入布局名称", "布局另存为", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  inputValidator: utils.saveLayoutInputValidator
                }).then(function (_ref) {
                  var value = _ref.value;

                  var _this$getCurrentLayou2 = _this.getCurrentLayoutInfo(),
                      visibleColumns = _this$getCurrentLayou2.visibleColumns,
                      columnSorting = _this$getCurrentLayou2.columnSorting,
                      fixedColumnsLeft = _this$getCurrentLayou2.fixedColumnsLeft,
                      colSettingsKey = _this$getCurrentLayou2.colSettingsKey,
                      groupColumns = _this$getCurrentLayou2.groupColumns;

                  _this.saveAsLayout({
                    visibleColumns: visibleColumns,
                    columnSorting: columnSorting,
                    fixedColumnsLeft: _this.showSelection ? fixedColumnsLeft - 1 : fixedColumnsLeft,
                    colSettingsKey: colSettingsKey,
                    layoutName: value,
                    groupColumns: groupColumns
                  });
                });
              },
              hidden: function hidden() {
                return !_this.currentLayoutName;
              }
            },
            removeLayout: {
              name: '<span class="el-icon-delete-solid hot-context-icon"></span>删除布局',
              callback: function callback() {
                _this.removeCurrentLayout();
              },
              hidden: function hidden() {
                return !_this.currentLayoutName;
              }
            },
            layoutSettings: {
              name: '<span class="el-icon-s-tools hot-context-icon"></span>布局配置...',
              callback: function callback() {
                _this3.startSettingLayout();
              }
            },
            autoColumnSize: {
              name: '<span class="el-icon-s-operation hot-context-icon"></span>列宽自适应',
              callback: function callback() {
                _this3.doAutoColumnSize();
              }
            },
            clearAllFilters: {
              name: '<span class="el-icon-remove hot-context-icon"></span>清除过滤',
              callback: function callback() {
                _this.clearAllFilters();
              }
            }
          }
        }; // 读取缓存配置

        var storageSettings = utils.localStorageGet("Layouts.".concat(newSettings["colSettingsKey"]));

        if (storageSettings) {
          var layoutSettingData = this.createLayoutSettingData(storageSettings);
          newSettings.columns = layoutSettingData.columns;
          newSettings.fixedColumnsLeft = layoutSettingData.fixedColumnsLeft;
          this.renderColumns = newSettings.columns;
          this.currentLayoutName = storageSettings.layoutName;
          this.currentLayout = storageSettings;
        } else {
          // 无缓存，读取配置信息
          this.currentLayout = {
            groupColumns: this.$props.groupColumns
          };
        }
      }

      if (this.filters === true || newSettings["showFilter"] && newSettings["showFilter"] !== "false") {
        newSettings["filters"] = true;
        newSettings["dropdownMenu"] = ["filter_by_value", "filter_action_bar"];
      }

      if (this.showSelection) {
        this.$el.classList.add("ht-has-selection");
      }

      if (newSettings["hideCheckbox"]) {
        this.$el.classList.add("ht-hide-checkbox");
      }

      newSettings.beforeKeyDown = function (e) {
        var key = e.keyCode;
        if (key !== 9 && key !== 113) Handsontable.dom.stopImmediatePropagation(e);
      };

      if (!this.showIndexColumn) {
        newSettings.rowHeaderWidth = 1;
      }

      newSettings.colWidths = [];
      newSettings.columns.forEach(function (c) {
        newSettings.colWidths.push(c.width);
        c.__width = c.width;
        delete c.width;
      });

      if (newSettings.autoColumnSize) {
        newSettings.colWidths = undefined;
      }

      if (hiddenColumns && hiddenColumns.length) {
        hiddenColumns = _toConsumableArray(new Set(hiddenColumns));

        if (newSettings.columns && newSettings.columns.length) {
          newSettings.columns = newSettings.columns.filter(function (__, i) {
            return hiddenColumns.indexOf(i) === -1;
          });
        }

        if (newSettings.colWidths && newSettings.colWidths.length) {
          newSettings.colWidths = newSettings.colWidths.filter(function (__, i) {
            return hiddenColumns.indexOf(i) == -1;
          });
        }

        delete newSettings.hiddenColumns;
        this.defaultHiddenColumns = hiddenColumns;
      }

      newSettings.rowHeaders = function (index) {
        if (!(_this3.pageSize && _this3.currentPage)) {
          return "".concat(index + 1);
        }

        return "".concat((_this3.currentPage - 1) * _this3.pageSize + 1 + index);
      };

      newSettings.filters = true;
      this.hotInstance = new Handsontable.Core(this.$el, newSettings);
      this.hotInstance.addHook("beforeStretchingColumnWidth", function (stretchedWidth, column) {
        var columnSetting = _this3.getColumnSettingAtCol(column);

        if (!columnSetting) {
          return "100%";
        }

        if (columnSetting.field === CHECK_COLUMN_NAME) {
          return columnSetting.width || columnSetting.__width || 60;
        }
      });
      this.hotInstance.init();

      if (this.autoRowStatus) {
        var filtersPlugin = this.hotInstance.getPlugin("filters");
        filtersPlugin.addCondition("rowStatus", "by_value", [[undefined, 2, 4, 16]]);
      }

      if (newSettings.autoColumnSize) {
        setTimeout(function () {
          _this3.hotInstance.updateSettings({
            autoColumnSize: true
          });
        });
      }

      this.resizeListener(autoResize);
      markIndexHeader(this.$el);
      markIndexSummary(this.$el);
      this.createEmptyTextElement();

      function markIndexHeader(el) {
        var cornerHeader = el.querySelectorAll(".cornerHeader");

        if (cornerHeader && cornerHeader !== null && cornerHeader.length > 0) {
          for (var i = 0; i < cornerHeader.length; i++) {
            if (cornerHeader[i].innerHTML !== _this.selectionColumnTitle) {
              cornerHeader[i].innerHTML = _this.selectionColumnTitle;
            }
          }
        }
      }

      function markIndexSummary(el) {
        if (!_this.hasSummary) {
          return;
        } // 没有显示序号列，合计第一列数据没有值显示文本合计


        if (!_this.showIndexColumn) {
          var trDom = el.querySelector(".htCore tbody tr:last-child");

          if (trDom) {
            var tdDom = trDom.querySelector("td:nth-child(2)");

            if (tdDom && (!tdDom.innerHTML || tdDom.innerHTML === "&nbsp;")) {
              tdDom.innerHTML = _this.sumColumnTitle;

              if (_this.sumColumnTitleBold) {
                tdDom.style.fontWeight = "bold";
              }
            }
          }
        } else {
          var _trDom = el.querySelector(".ht_clone_left .htCore tbody tr:last-child");

          if (_trDom) {
            var thDom = _trDom.querySelector("th .rowHeader");

            if (thDom && thDom.innerHTML != 1) {
              thDom.innerHTML = _this.sumColumnTitle;

              if (_this.sumColumnTitleBold) {
                thDom.style.fontWeight = "bold";
              }
            }
          }
        }

        var tdDoms = el.querySelectorAll(".htCore tbody tr:last-child td");

        if (tdDoms && tdDoms !== null && tdDoms.length > 0 && _this.sumColumnTitleBold) {
          for (var i = 0; i < tdDoms.length; i++) {
            tdDoms[i].style.fontWeight = "bold";
          }
        }
      }

      this.hotInstance.addHook("afterRender", function () {
        var el = _this3.$el;
        markIndexHeader(el);
        markIndexSummary(_this3.$el);
      }); // 后端排序

      if (this.backEndSortHandle) {
        this.hotInstance.addHook("beforeColumnSort", function (currentSortConfig, destinationSortConfigs) {
          [].concat(_toConsumableArray(currentSortConfig), _toConsumableArray(destinationSortConfigs)).forEach(function (c) {
            c.field = _this3.hotInstance.colToProp(c.column);
          });
          var field = destinationSortConfigs.length > 0 ? destinationSortConfigs[0].field : currentSortConfig[0].field;
          if (_this3.allowColumnSorting.indexOf(field) === -1) return false;
        });
        this.hotInstance.addHook("afterColumnSort", function (currentSortConfig, destinationSortConfigs) {
          [].concat(_toConsumableArray(currentSortConfig), _toConsumableArray(destinationSortConfigs)).forEach(function (c) {
            c.field = _this3.hotInstance.colToProp(c.column);
          });
          var field = destinationSortConfigs.length > 0 ? destinationSortConfigs[0].field : "";
          if (_this3.allowColumnSorting.indexOf(field) === -1) return;

          _this3.backEndSortHandle(destinationSortConfigs, currentSortConfig);

          var columnSortPlugin = _this3.hotInstance.getPlugin("multiColumnSorting");

          if (!(columnSortPlugin && columnSortPlugin.enabled)) {
            columnSortPlugin = _this3.hotInstance.getPlugin("columnSorting");
          }

          columnSortPlugin.setSortConfig(destinationSortConfigs);
          return false;
        });
      } else {
        this.hotInstance.addHook("beforeColumnSort", function (currentSortConfig, destinationSortConfigs) {
          if (!_this3.isEditing()) {
            return true;
          }

          var columnSortPlugin = _this3.hotInstance.getPlugin("multiColumnSorting");

          if (!(columnSortPlugin && columnSortPlugin.enabled)) {
            columnSortPlugin = _this3.hotInstance.getPlugin("columnSorting");
          }

          _this3.finishEdit(function () {
            setTimeout(function () {
              columnSortPlugin.sort(destinationSortConfigs);
            }, 10);
          });

          return false;
        });
      }

      this.hotSettings = newSettings;
      this.hotSettings.frontSorting = this.hotSettings.frontSorting !== false;
      this.hotSettings["showSelection"] = this.showSelection;

      this.$el.ondblclick = function (evt) {
        if (!evt) evt = window.event;
        var target = evt.target;
        var td = Handsontable.dom.closest(target, ["TD"]);

        if (!td) {
          return;
        }

        if (!td.classList.contains("wtBorder") && !td.classList.contains("current")) return;
        var coords, row, col, record, prop, physicalRow;

        if (td.tagName === "TD") {
          coords = _this3.hotInstance.getCoords(td);
          row = coords.row;
          col = coords.col;
        } else {
          coords = _this3.hotInstance.getSelected()[0];
          row = coords[0];
          col = coords[1];
        }

        physicalRow = _this3.hotInstance.toPhysicalRow(row);
        if (_this3.showSelection && col === 0 || row < 0) return;
        record = _this3.getRecord(physicalRow);
        prop = _this3.hotInstance.colToProp(col);

        var r = _this3.$emit("cellDblclick", {
          record: record,
          col: col,
          row: row,
          physicalRow: physicalRow,
          field: prop,
          e: evt
        });

        if (r !== false) _this3.$emit("rowDblclick", {
          record: record,
          row: row,
          physicalRow: physicalRow
        });
      };

      if (this.dragCheck) {
        this.hotInstance.addHook("afterOnCellMouseDown", function (event, coords) {
          var prop = _this3.hotInstance.colToProp(coords.col);

          if ((prop === "$$checked" || coords.col === -1) && coords.row >= 0) {
            _this3.dragStartRow = coords.row;
          }
        });
        this.hotInstance.addHook("afterOnCellMouseUp", function (event, coords) {
          var obj = {
            row: coords.row,
            col: coords.col == -1 ? 0 : coords.col
          };
          var selectionCellRange = _this3.hotInstance.view.wt.selections.cell.cellRange;

          if (selectionCellRange != null) {
            selectionCellRange.from = selectionCellRange.highlight = selectionCellRange.to = obj;

            _this3.hotInstance.selectCell(obj.row, obj.col); // this.hotInstance.selection.refreshBorders();

          }

          if (typeof _this3.dragStartRow === "number") {
            var end,
                start = _this3.dragStartRow,
                prop = _this3.hotInstance.colToProp(coords.col);

            _this3.dragStartRow = undefined;

            if ((prop === "$$checked" || coords.col === -1) && coords.row >= 0) {
              end = coords.row;

              if (start === end) {
                return;
              }

              _this3.finishDragCheck(start, end);
            }
          }
        });
      }

      if (this.hasSummary) {
        this.hotInstance.addHook("afterGetRowHeader", function (row, TH) {
          row = _this3.hotInstance.toPhysicalRow(row);

          if (_this3.isSummaryRow(row)) {
            TH.querySelector(".rowHeader").innerHTML = "\u5408\u8BA1";
          } else {
            if (_this3.summaryPosition === "first") TH.querySelector(".rowHeader").innerHTML = row;
          }
        });

        if (newSettings["showFilter"] && newSettings["showFilter"] !== "false") {
          this.hotInstance.addHook("partakeFilter", function (row) {
            return !_this3.isSummaryRow(row);
          });
        }
      }

      if (typeof newSettings["css"] === "function") {
        this.hotInstance.addHook("afterGetRowHeader", function (row, TH) {
          var physicalRow = _this3.hotInstance.toPhysicalRow(row);

          var record = _this3.getRecord(physicalRow);

          newSettings["css"]({
            record: record,
            tr: TH.parentElement
          });
        });
      }

      this.hotInstance.addHook("beforeOnCellMouseDown", function (evt, coords) {
        var row = coords.row,
            col = coords.col,
            physicalRow = _this3.hotInstance.toPhysicalRow(row);

        if (evt.target.className.indexOf("ht-check-all") !== -1) {
          _this3.toggleAll(!evt.target.checked);
        } else if (evt.target.className.indexOf("hc-check-all") !== -1) {
          _this3.toggleColunmAll(!evt.target.checked, col);
        } else if (row === -1 && evt.target.className.indexOf("sort-caret") > -1) {
          evt.stopImmediatePropagation(); // const column = newSettings.columns[col];
          // const column = this.getCurrentLayoutInfo().visibleColumns[col - 1];
          // let sortName = column.field;

          var columnFields = _this3.hotInstance.getColHeader().map(function (title, i) {
            return _this3.hotInstance.colToProp(i);
          });

          var sortName = columnFields[col];
          var sortDirection = evt.target.className.indexOf("ascending") !== -1 ? SORT_DIRECTION.ASC : SORT_DIRECTION.DESC;

          _this3.doSort(sortName, sortDirection, evt.ctrlKey);
        } else if (evt.target.className.indexOf("expand-toggle") !== -1 || evt.target.className.indexOf("ht-group-expand") !== -1) {
          var plugin = _this3.hotInstance.getPlugin("nestedRows");

          var collapsingUI = plugin.collapsingUI;
          row = collapsingUI.translateTrimmedRow(row);
          var areChildrenCollapsed = collapsingUI.areChildrenCollapsed(row);

          if (areChildrenCollapsed) {
            collapsingUI.expandChildren(row);
          } else {
            collapsingUI.collapseChildren(row);
          }
        } else if (evt.target.className.indexOf("ht-column-title-text") > -1) {
          _this3.$emit("headerClick", {
            row: row,
            col: col,
            physicalRow: physicalRow,
            e: evt
          });
        }

        _this3.formData = _this3.getRecord(physicalRow);
      });

      if (newSettings["colSettingsKey"]) {
        this.hotInstance.addHook("beforeOnCellMouseDown", this._onClickSettingsButton);
        this.hotInstance.addHook("beforeOnCellContextMenu", function (event, coords) {
          // 仅在表头显示右键菜单
          if (coords.row === -1) {
            return;
          }

          event.stopImmediatePropagation();
        });
        this.hotInstance.addHook("beforeContextMenuSetItems", function (items) {
          var layoutSettingsList = (_this.layoutSettingsList || []).map(function (item) {
            var hiddenClass = _this.currentLayoutName === item.layoutName ? "" : "hot-context-icon-hidden";
            return {
              key: item.gridLayoutId,
              name: "<span class=\"el-icon-check hot-context-icon ".concat(hiddenClass, "\"></span>").concat(item.layoutName),
              callback: function callback() {
                var content = JSON.parse(item.content);
                content.type = "Change";
                content.layoutName = item.layoutName;
                if (_this.showSelection) content.fixedColumnsLeft--;

                _this.updateLayoutSetting(content);
              }
            };
          });
          var defaultItem = items.find(function (item) {
            return item.key == "defaultLayout";
          });

          if (defaultItem) {
            defaultItem.name = defaultItem.name.replace(/hot-context-icon-hidden/g, "");

            if (_this.currentLayoutName) {
              defaultItem.name = defaultItem.name.replace("hot-context-icon", "hot-context-icon hot-context-icon-hidden");
            }
          }

          items.unshift.apply(items, _toConsumableArray(layoutSettingsList));
        }); // 布局配置面板出现前的钩子

        this.hotInstance.addHook("afterContextMenuShow", function (context) {
          var containerZindex = parseInt(_this.getZindex(_this.$el));
          context.menu.container.style.zIndex = (containerZindex + 1).toString();
        }); // 过滤面板出现前的钩子

        this.hotInstance.addHook("afterDropdownMenuShow", function (dropdownMenu) {
          var containerZindex = parseInt(_this.getZindex(_this.$el));
          dropdownMenu.menu.container.style.zIndex = (containerZindex + 1).toString();
        });

        this._getLayoutSettingsList();
      }

      this.hotInstance.addHook("modifyColWidth", function (width, col) {
        if (!newSettings.autoColumnSize) {
          return width;
        }

        if (newSettings.columns[col].maxWidth) {
          var maxWidth = parseInt(newSettings.columns[col].maxWidth);
          return Math.min(width, maxWidth);
        } else {
          return width + 3;
        }
      });
      this.hookHandle();
      preventInternalEditWatch(this);
      this.handleColHeaderHook();
      this.handleHotTableRenderListener();
    },
    buildColumns: function buildColumns(settings, hiddenColumns) {
      var _this4 = this;

      if (Array.isArray(settings.columns)) {
        if (this.showSelection && settings.columns[0].data !== CHECK_COLUMN_NAME) {
          settings.columns.splice(0, 0, this.getSelectionColumn());
        }

        if (settings["fixedColumnsLeft"] !== undefined) {
          settings["fixedColumnsLeft"] = this.showSelection ? 1 : 0;
        }

        settings.columns.forEach(function (column, index) {
          if (!column.editor) column.editor = false;
          if (column.hidden) hiddenColumns.push(index);
          delete column.hidden;

          if (!column.text && column.title) {
            column.text = column.title;
            delete column.title;
          }

          if (!column.validator) {
            var validator = _this4.createDefaultValidator(column);

            if (validator) {
              column.validator = validator;
            }
          }
        });
      }
    },
    getTabIndexConfig: function getTabIndexConfig() {
      return Handsontable.helper.getProperty(this.$ELEMENT, "config.hotTable.tabIndexKey") || this.tabIndexKey || {};
    },
    isTabIndexPrevKey: function isTabIndexPrevKey(e) {
      return this.isTabIndexKey(e, "prevKey");
    },
    isTabIndexNextKey: function isTabIndexNextKey(e) {
      return this.isTabIndexKey(e, "nextKey");
    },
    isTabIndexKey: function isTabIndexKey(e, type) {
      var keyConfigs = this.getTabIndexConfig()[type];

      if (!(keyConfigs && e)) {
        return false;
      }

      if (!Array.isArray(keyConfigs)) {
        keyConfigs = [keyConfigs];
      }

      var result = false;

      for (var i = 0; i < keyConfigs.length; i++) {
        var keyConfig = keyConfigs[i] || {};
        var key = (e.key || "").toLowerCase();
        var ctrlKey = !!e.ctrlKey;
        var shiftKey = !!e.shiftKey;
        var altKey = !!e.altKey;
        var configKey = (keyConfig.key || "").toLowerCase();
        var configCtrlKey = !!keyConfig.ctrl;
        var configShiftKey = !!keyConfig.shift;
        var configAltKey = !!keyConfig.alt;
        result = key === configKey && ctrlKey === configCtrlKey && shiftKey === configShiftKey && altKey === configAltKey;

        if (result) {
          break;
        }
      }

      return result;
    },
    tabEditNext: function tabEditNext(currentRow, currentCol) {
      var _this5 = this;

      var next = this.getNextEditableCell(currentRow, currentCol);

      if (!next) {
        return;
      }

      this.finishEdit(function () {
        _this5.hotInstance.selectCell(next.row, next.col);

        _this5.startEdit(next.row, next.col);
      });
    },
    tabEditPrev: function tabEditPrev(currentRow, currentCol) {
      var _this6 = this;

      var prev = this.getPrevEditableCell(currentRow, currentCol);

      if (!prev) {
        return;
      }

      this.finishEdit(function () {
        _this6.hotInstance.selectCell(prev.row, prev.col);

        _this6.startEdit(prev.row, prev.col);
      });
    },
    getNextEditableCell: function getNextEditableCell(currentRow, currentCol) {
      var columns = this.hotInstance.getSettings().columns;
      var colCount = this.hotInstance.countCols();
      var rowCount = this.hotInstance.countRows();
      var nextRow = currentRow;
      var nextCol = currentCol + 1;

      while (true) {
        if (nextCol > colCount - 1) {
          nextCol = 0;
          nextRow++;

          if (nextRow > rowCount - 1) {
            return false;
          }
        }

        if (nextCol === currentCol) {
          return false;
        }

        var column = columns[nextCol];

        if ((column.editor || column.type === "checkbox") && column.data !== CHECK_COLUMN_NAME) {
          break;
        }

        nextCol++;
      }

      return {
        row: nextRow,
        col: nextCol
      };
    },
    getPrevEditableCell: function getPrevEditableCell(currentRow, currentCol) {
      var columns = this.hotInstance.getSettings().columns;
      var colCount = this.hotInstance.countCols();
      var rowCount = this.hotInstance.countRows();
      var nextRow = currentRow;
      var nextCol = currentCol - 1;

      while (true) {
        if (nextCol < 0) {
          nextCol = colCount - 1;
          nextRow--;

          if (nextRow < 0) {
            return false;
          }
        }

        if (nextCol === currentCol) {
          return false;
        }

        var column = columns[nextCol];

        if ((column.editor || column.type === "checkbox") && column.data !== CHECK_COLUMN_NAME) {
          break;
        }

        nextCol--;
      }

      return {
        row: nextRow,
        col: nextCol
      };
    },
    handleHotTableRenderListener: function handleHotTableRenderListener() {
      var _this7 = this;

      if (!this.$bus) {
        return;
      }

      var handle = function handle() {
        if (document.contains(_this7.$el) && Handsontable.dom.isVisible(_this7.$el)) {
          _this7.hotInstance && _this7.hotInstance.render();
        }
      };

      this.$bus.$on("hotTableRender", handle);
      this.destroyHandlers.push(function () {
        _this7.$bus.$off("hotTableRender", handle);
      });
    },
    handleColHeaderHook: function handleColHeaderHook() {
      var _this8 = this;

      if (!((this.showFilter || this.filters) && this.columnSettings && this.columnSettings.find(function (c) {
        return c.showFilter === false;
      }))) {
        return;
      }

      this.hotInstance.addHook("afterGetColHeader", function (index, TH) {
        var column = _this8.renderColumns && _this8.renderColumns.length > 0 ? _this8.renderColumns[index] : _this8.columnSettings[index];

        if (column && column.showFilter === false) {
          Handsontable.dom.addClass(TH, "hotHiddenFilter");
        }
      });
    },
    getGlobalRendererVNode: function getGlobalRendererVNode() {
      var hotTableSlots = this.$slots["default"] || [];
      return findVNodeByType(hotTableSlots, "hot-renderer");
    },
    getGlobalEditorVNode: function getGlobalEditorVNode() {
      var hotTableSlots = this.$slots["default"] || [];
      return findVNodeByType(hotTableSlots, "hot-editor");
    },
    createEmptyTextElement: function createEmptyTextElement() {
      if (!this.emptyText) {
        return;
      }

      var div = document.createElement("div");
      var wtHolder = this.$el.querySelector(".wtHolder");
      div.className = "hotEmptyTextContainer";
      div.innerHTML = "<span class=\"hotEmptyText\">".concat(this.emptyText, "</span>");
      wtHolder.appendChild(div);
      this.hotEmptyTextContainer = div;
      this.hotInstance.addHook("afterScrollHorizontally", function (a, b, c, d) {
        div.style.left = "".concat(wtHolder.scrollLeft, "px");
      });
    },

    /**
     * Get settings for the columns provided in the `hot-column` components.
     */
    getColumnSettings: function getColumnSettings() {
      var _this9 = this;

      var hotColumns = getHotColumnComponents(this.$children);
      var usesRendererComponent = false;
      var columnSettings = hotColumns.map(function (elem) {
        if (elem.usesRendererComponent) {
          usesRendererComponent = true;
        }

        return _objectSpread2({}, elem.columnSettings);
      });
      hotColumns.forEach(function (c) {
        if (c.mergeColumn) {
          _this9.hasMergeColumn = true;
          _this9.mergeColumnInfo[c.data] = true;
        }
      });

      if (usesRendererComponent && this.settings && (this.settings.autoColumnSize !== false || this.settings.autoRowSize) && (this.autoColumnSize !== false || this.autoRowSize)) {
        console.warn("Your `hot-table` configuration includes both `hot-column` and `autoRowSize`/`autoColumnSize`, which are not compatible with each other " + "in this version of `@handsontable/vue`. Disable `autoRowSize` and `autoColumnSize` to prevent row and column misalignment.");
      }

      return columnSettings.length ? columnSettings : void 0;
    },
    getNestedHeaderSettings: function getNestedHeaderSettings() {
      if (!this.$children.find(function (c) {
        return c.$options.name === "HotNestedHeader";
      })) {
        return;
      }

      var result = [];
      var columnsArr = [];
      var columnIndexMap = {};
      var nestedLevelMap = {};
      var nestedStartIndexMap = {};
      var columnIndex = 0;
      forChildren(this.$children || []);
      result.forEach(function (levelArr) {
        levelArr.length = columnsArr.length;
        var span = 0;

        for (var i = 0; i < columnsArr.length; i++) {
          if (levelArr[i]) {
            span = levelArr[i].colspan;
          }

          if (span > 0) {
            span--;

            if (!levelArr[i]) {
              levelArr[i] = false;
            }
          } else {
            levelArr[i] = "";
          }
        }
      });
      result = result.map(function (levelArr) {
        return levelArr.filter(function (nh) {
          return nh !== false;
        });
      });
      result.push(columnsArr);
      return result;

      function forChildren(_children) {
        _children.forEach(function (c) {
          if (c.$options.name === "HotColumn") {
            columnsArr.push(c.title);
            columnIndexMap[c._uid] = columnIndex++;
            addColspan(c.$parent);
            return;
          }

          if (c.$options.name === "HotNestedHeader") {
            var parent = c.$parent;
            nestedStartIndexMap[c._uid] = columnIndex;

            if (nestedLevelMap[parent._uid] >= 0) {
              nestedLevelMap[c._uid] = nestedLevelMap[parent._uid] + 1;
            } else {
              nestedLevelMap[c._uid] = 0;
            }

            forChildren(c.$children);
          }
        });
      }

      function addColspan(c) {
        if (!(c && c.$options.name === "HotNestedHeader")) {
          return;
        }

        var level = nestedLevelMap[c._uid] || 0;
        var startIndex = nestedStartIndexMap[c._uid];
        result[level] = result[level] || [];
        result[level][startIndex] = result[level][startIndex] || {
          label: c.title,
          _name: c.name,
          colspan: 0
        };
        result[level][startIndex].colspan++;
        addColspan(c.$parent);
      }
    },
    getDynamicColumnsSettings: function getDynamicColumnsSettings() {
      var dynamicColumnsComponentIndex = this.$children.findIndex(function (c) {
        return c.$options.name === "HotDynamicColumns";
      });
      var dynamicColumnsComponent = this.$children[dynamicColumnsComponentIndex];

      if (!dynamicColumnsComponent) {
        return null;
      }

      var hotColumns = dynamicColumnsComponent.$children.filter(function (c) {
        return c.$options.name === "HotColumn";
      });
      var columnSettings = hotColumns.map(function (c) {
        return _objectSpread2({}, c.columnSettings);
      });
      return {
        data: dynamicColumnsComponent.data,
        title: dynamicColumnsComponent.title,
        columns: columnSettings,
        index: dynamicColumnsComponentIndex
      };
    },

    /**
     * Create the wrapper function for the provided renderer child component.
     *
     * @param {Object} vNode VNode of the renderer child component.
     * @param {Boolean} containerComponent Instance of the component, which will be treated as a parent for the newly created renderer component.
     * @returns {Function} The wrapper function used as the renderer.
     */
    getRendererWrapper: function getRendererWrapper(vNode, containerComponent) {
      var $vm = this;
      return function (instance, TD, row, col, prop, value, cellProperties) {
        // Prevent caching and rendering of the GhostTable table cells
        var dataSource = $vm.dataSource || [];
        var rowCount = instance.countRows();
        var isFirstRow = row === 0;
        var isLastRow = row === rowCount - 1;
        var physicalRow = instance.toPhysicalRow(row);
        var record = $vm.getRecord(physicalRow);

        if (TD
        /*  && !TD.getAttribute('ghost-table') */
        ) {
            var rendererCache = $vm.rendererCache;
            var rendererArgs = {
              hotInstance: instance,
              TD: TD,
              row: row,
              col: col,
              prop: prop,
              value: value,
              dataSource: dataSource,
              cellProperties: cellProperties,
              isRenderer: true,
              isFirstRow: isFirstRow,
              isLastRow: isLastRow,
              record: record,
              physicalRow: physicalRow
            };

            if (rendererCache && !rendererCache.has("".concat(row, "-").concat(col))) {
              var mountedComponent = createVueComponent(vNode, containerComponent, {}, rendererArgs);
              rendererCache.set("".concat(row, "-").concat(col), {
                component: mountedComponent,
                lastUsedTD: null
              });
            }

            var cachedEntry = rendererCache.get("".concat(row, "-").concat(col));
            var cachedComponent = cachedEntry.component;
            var cachedTD = cachedEntry.lastUsedTD;
            Object.assign(cachedComponent.$data, rendererArgs);

            if (!cachedComponent.$el.parentElement || cachedTD !== TD) {
              // Clear the previous contents of a TD
              while (TD.firstChild) {
                TD.removeChild(TD.firstChild);
              }

              TD.appendChild(cachedComponent.$el);
              cachedEntry.lastUsedTD = TD;
            }
          }

        return TD;
      };
    },

    /**
     * Create a fresh class to be used as an editor, based on the editor component provided.
     *
     * @param {Object} vNode VNode for the editor child component.
     * @param {Boolean} containerComponent Instance of the component, which will be treated as a parent for the newly created editor component.
     * @param {String} editorName editor cache key
     * @returns {Class} The class used as an editor in Handsontable.
     */
    getEditorClass: function getEditorClass(vNode, containerComponent, editorName) {
      var componentName = editorName || vNode.componentOptions.Ctor.options.name;
      var editorCache = this.editorCache;
      var mountedComponent = null;
      var cachedEditor = editorCache.get(componentName); // 销毁旧的 editor

      if (cachedEditor) {
        cachedEditor.$destroy();
      }

      mountedComponent = createVueComponent(vNode, containerComponent, {}, {
        isEditor: true
      });
      editorCache.set(componentName, mountedComponent);
      return mountedComponent.$data.hotCustomEditorClass;
    },
    reset: function reset() {
      this.error = {};
    },
    getSelections: function getSelections() {
      var _this10 = this;

      var pluginNestedRow = this.hotInstance.getPlugin("nestedRows"),
          rows = pluginNestedRow && pluginNestedRow.dataManager && pluginNestedRow.dataManager.cache && pluginNestedRow.dataManager.cache.rows && pluginNestedRow.dataManager.cache.rows.length > 0 ? pluginNestedRow.dataManager.cache.rows : this.dataSource;
      return rows.filter(function (record, i) {
        if (_this10.isSummaryRow(record)) return false; // const trimRowsPlugin = this.hotInstance.getPlugin('trimRows');
        //if (trimRowsPlugin && trimRowsPlugin.trimmedRows.includes(i)) return false;
        // if (
        //   this.hotSettings.filters &&
        //   this.hotInstance.runHooks("assertFilter", i)
        // )
        //   return false;

        return record[CHECK_COLUMN_NAME];
      });
    },
    getActualSelections: function getActualSelections() {
      var rows = this.getSelections();
      return rows.filter(function (record, i) {
        return !record[GROUP_RECORD_FLAG_NAME];
      });
    },
    getSelected: function getSelected() {
      var selected = this.hotInstance.getSelected();

      if (selected) {
        var physicalRow = this.hotInstance.toPhysicalRow(selected[0][0]);
        return this.getRecord(physicalRow);
      } else {
        return undefined;
      }
    },
    getSelectedIndex: function getSelectedIndex() {
      var selected = this.hotInstance.getSelected();

      if (selected) {
        return selected[0];
      } else {
        return undefined;
      }
    },
    doAutoColumnSize: function doAutoColumnSize() {
      var plugin = this.hotInstance.getPlugin("manualColumnResize");
      plugin.manualColumnWidths = [];
      this.hotInstance.updateSettings({
        autoColumnSize: true,
        colWidths: undefined
      });
    },
    hookHandle: function hookHandle() {
      var _this11 = this;

      if (this.$props.showFilter) {
        this.hotInstance.addHook("afterFilter", function (filterColumns) {
          _this11.$emit("afterFilter", filterColumns);
        });
      }

      this.hotInstance.addHook("afterOnCellMouseUp", function (event, coords) {
        if (Handsontable["isEditorMousdown"]) {
          return;
        }

        var row = coords.row,
            col = coords.col,
            physicalRow = _this11.hotInstance.toPhysicalRow(row),
            physicalCol = _this11.hotInstance.toPhysicalColumn(col);

        if (row > -1) {
          var record = _this11.getRecord(physicalRow);

          var result = _this11.$emit("cellClick", {
            record: record,
            row: row,
            physicalRow: physicalRow,
            physicalCol: physicalCol,
            col: col,
            e: event
          });

          if (result !== false) {
            _this11.$emit("rowClick", {
              record: record,
              row: row,
              physicalRow: physicalRow,
              e: event
            });
          }
        }
      });
      this.hotInstance.addHook("afterColumnSort", function (currentSortConfig, destinationSortConfigs) {
        return _this11.$emit("afterColumnSort", currentSortConfig, destinationSortConfigs);
      });
      this.hotInstance.addHook("beforeColumnSort", function (currentSortConfig, destinationSortConfigs) {
        _this11.$emit("beforeColumnSort", currentSortConfig, destinationSortConfigs);
      });
      this.hotInstance.addHook("afterScrollHorizontally", function (currentSortConfig, destinationSortConfigs) {
        _this11.finishEdit();
      });
      this.hotInstance.addHook("afterScrollVertically", function (currentSortConfig, destinationSortConfigs) {
        _this11.finishEdit();
      });
      this.hotInstance.addHook("afterChange", function (changes) {
        if (changes) {
          changes.forEach(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 4),
                row = _ref3[0],
                prop = _ref3[1],
                oldValue = _ref3[2],
                newValue = _ref3[3];

            if (prop === CHECK_COLUMN_NAME) {
              var physicalRow = _this11.hotInstance.toPhysicalRow(row);

              var record = _this11.getRecord(physicalRow);

              if (!record) {
                return;
              }

              record[CHECK_COLUMN_NAME] = newValue;

              _this11.selectionChange(physicalRow, newValue);

              _this11.$emit("selectionChange", {
                isAll: false,
                checked: newValue,
                record: record
              });
            } else {
              _this11.$emit("valueChange", {
                prop: prop,
                newValue: newValue,
                oldValue: oldValue
              });
            }
          });
        }
      });
      this.addKeydownHook(); // 根据数据合并表格列处理
      // if (this.needMergeColumns) {
      //   this.hotInstance.addHook('afterLoadData', () => {
      //     if (!this.needMergeColumns) {
      //       return;
      //     }
      //     const columnSettings = this.columnSettings;
      //     const dataSource = this.finalData;
      //     const mergeCells = [];
      //     let groups = dataSource && dataSource.length > 1
      //       ? [dataSource.map((item, index) => {
      //           return {
      //             item,
      //             index,
      //           }
      //         })]
      //       : [];
      //     const mergesInfo = [];
      //     for (let col = 0; col < columnSettings.length; col++) {
      //       if (!groups.length) {
      //         break
      //       }
      //       let currentGroups = [];
      //       const c = columnSettings[col];
      //       const field = c.data;
      //       if (field === CHECK_COLUMN_NAME) {
      //         continue;
      //       }
      //       if (this.hasMergeColumn && !this.mergeColumnInfo[field]) {
      //         break;
      //       }
      //       groups.forEach(group => {
      //         let prevValue = {};
      //         let currentGroup = null;
      //         let lastIndex = group.length - 1;
      //         group.forEach((itemInfo, i) => {
      //           const value = itemInfo.item[field];
      //           if (value === prevValue) {
      //             if (!currentGroup) {
      //               currentGroup = [group[i - 1]];
      //             }
      //             currentGroup.push(itemInfo);
      //           }
      //           if (value !== prevValue || i === lastIndex){
      //             if (currentGroup && currentGroup.length > 1) {
      //               currentGroups.push(currentGroup);
      //             }
      //             currentGroup = null;
      //           }
      //           prevValue = value;
      //         });
      //       });
      //       groups = currentGroups;
      //       if (groups.length) {
      //         mergesInfo[col] = groups;
      //       }
      //     }
      //     mergesInfo.forEach((colMergesInfo, col) => {
      //       colMergesInfo.forEach(group => {
      //         const row = group[0].index;
      //         const rowspan = group.length;
      //         mergeCells.push({
      //           col,
      //           row,
      //           rowspan,
      //           colspan: 1,
      //         });
      //       });
      //     });
      //     this.hotInstance.updateSettings({
      //       mergeCells,
      //     });
      //   });
      // }

      this.addDynamicColumnsHook();
      this.addCalculateHook();
      this.addColumnMoveHook();
    },
    getMergeCells: function getMergeCells(data) {
      var _this12 = this;

      if (!this.needMergeColumns) {
        return;
      }

      var columnSettings = this.columnSettings;
      var dataSource = data || this.finalData;
      var mergeCells = [];
      var groups = dataSource && dataSource.length > 1 ? [dataSource.map(function (item, index) {
        return {
          item: item,
          index: index
        };
      })] : [];
      var mergesInfo = [];

      var _loop2 = function _loop2(col) {
        if (!groups.length) {
          return "break";
        }

        var currentGroups = [];
        var c = columnSettings[col];
        var field = c.data;

        if (field === CHECK_COLUMN_NAME) {
          return "continue";
        }

        if (_this12.hasMergeColumn && !_this12.mergeColumnInfo[field]) {
          return "break";
        }

        groups.forEach(function (group) {
          var prevValue = {};
          var currentGroup = null;
          var lastIndex = group.length - 1;
          group.forEach(function (itemInfo, i) {
            var value = itemInfo.item[field];

            if (value === prevValue) {
              if (!currentGroup) {
                currentGroup = [group[i - 1]];
              }

              currentGroup.push(itemInfo);
            }

            if (value !== prevValue || i === lastIndex) {
              if (currentGroup && currentGroup.length > 1) {
                currentGroups.push(currentGroup);
              }

              currentGroup = null;
            }

            prevValue = value;
          });
        });
        groups = currentGroups;

        if (groups.length) {
          mergesInfo[col] = groups;
        }
      };

      _loop: for (var col = 0; col < columnSettings.length; col++) {
        var _ret = _loop2(col);

        switch (_ret) {
          case "break":
            break _loop;

          case "continue":
            continue;
        }
      }

      mergesInfo.forEach(function (colMergesInfo, col) {
        colMergesInfo.forEach(function (group) {
          var row = group[0].index;
          var rowspan = group.length;
          mergeCells.push({
            col: col,
            row: row,
            rowspan: rowspan,
            colspan: 1
          });
        });
      });
      return mergeCells;
    },
    addColumnMoveHook: function addColumnMoveHook() {
      var _this13 = this;

      this.hotInstance.addHook("beforeColumnMove", function (columns, target) {
        var from = columns[0];

        if (from === 0 || target === 0 || target === from + 1) {
          // 复选框列不进行拖动调整
          return false;
        }

        var columnSettings = _toConsumableArray(_this13.hotInstance.getSettings().columns) || [];
        var fromColumnSetting = columnSettings[from];
        columnSettings[from] = false;
        columnSettings.splice(target, 0, fromColumnSetting);
        columnSettings = columnSettings.filter(function (v) {
          return !!v;
        });
        setTimeout(function () {
          _this13.hotInstance.updateSettings({
            columns: columnSettings,
            colWidths: columnSettings.map(function (c) {
              return c.__width;
            })
          });
        });
        return false;
      });
    },
    addKeydownHook: function addKeydownHook() {
      var _this14 = this;

      this.hotInstance.addHook("afterDocumentKeyDown", function (e) {
        if (!_this14.isEditing()) {
          return;
        }

        _this14.keyDownHandle(e, true);
      });
      this.hotInstance.addHook("beforeKeyDown", function (e) {
        if (_this14.isEditing()) {
          return;
        }

        _this14.keyDownHandle(e, false);
      });
      this.hotInstance.addHook("afterSelection", function (row, col) {
        if (_this14.keepEditing && !(_this14.keepEditing.row === row && _this14.keepEditing.col === col)) {
          _this14.keepEditing = false;
        }
      });
    },
    keyDownHandle: function keyDownHandle(e, isEditing) {
      var key = e.keyCode;
      var selected = this.hotInstance.getSelected();

      if (!selected) {
        return;
      }

      var row = selected[0][0];
      var col = selected[0][1];
      e["__fromHotTable"] = true;

      if (this.isTabIndexNextKey(e)) {
        this.tabEditNext(row, col);
        return;
      }

      if (this.isTabIndexPrevKey(e)) {
        this.tabEditPrev(row, col);
        return;
      }

      if (!isEditing) {
        if (key === 38) {
          // 上
          this.hotInstance.selectCell(row - 1, col);
        } else if (key === 40) {
          // 下
          this.hotInstance.selectCell(row + 1, col);
        } else if (key === 37) {
          // 左
          this.hotInstance.selectCell(row, col - 1);
        } else if (key === 39) {
          // 右
          this.hotInstance.selectCell(row, col + 1);
        }

        if (key === 9 && this.keepEditing) {
          e.shiftKey ? col-- : col++;
        } else {
          return;
        }
      }

      var columnSettings = this.getCurrentColumnSettings();

      if (key === 9) {
        // TAB
        e.stopImmediatePropagation();
        e.preventDefault();
        var actionColumn;

        if (e.shiftKey) {
          for (var i = col; i > 0; i--) {
            if (columnSettings[i].type === "checkbox" || columnSettings[i].editor && columnSettings[i].data !== CHECK_COLUMN_NAME) {
              actionColumn = i;
              break;
            }
          }
        } else {
          for (var _i = col; _i < columnSettings.length; _i++) {
            if (columnSettings[_i].type === "checkbox" || columnSettings[_i].editor && columnSettings[_i].data !== CHECK_COLUMN_NAME) {
              actionColumn = _i;
              break;
            }
          }
        }

        if (actionColumn === undefined) return;
        this.hotInstance.selectCell(row, actionColumn);

        if (columnSettings[actionColumn].type !== "checkbox") {
          this.startEdit(row, actionColumn);
        } else {
          this.keepEditing = {
            row: row,
            col: actionColumn
          };
        }

        return;
      }

      var editorName = columnSettings[col].editorName;

      if (!((key === 38 || key === 40) && editorName && (editorName.indexOf("BaseInputEditor") === 0 || editorName.indexOf("ElInputEditor") === 0))) {
        return;
      }

      var actionRow;

      if (key === 38 && row > 0) {
        actionRow = row - 1;
      } else if (key === 40 && row < this.hotInstance.countRows() - 1) {
        actionRow = row + 1;
      }

      if (actionRow !== undefined) {
        e.stopImmediatePropagation();
        e.preventDefault();
        this.hotInstance.selectCell(actionRow, col);
        this.startEdit(actionRow, col);
      }
    },
    getCurrentColumnSettings: function getCurrentColumnSettings() {
      var _this15 = this;

      var colsCount = this.hotInstance.countCols();
      var columnSettings = this.columnSettings;
      var result = [];
      columnSettings.forEach(function (c) {
        var colIndex = _this15.hotInstance.propToCol(c.data);

        if (colIndex >= 0 && colIndex < colsCount) {
          result[colIndex] = c;
        }
      });
      return result;
    },
    isEditing: function isEditing() {
      var activeEditor = this.hotInstance.getActiveEditor();
      var editing = activeEditor && activeEditor["_opened"] || false;
      return editing;
    },
    handleDynamicColumnsHook: function handleDynamicColumnsHook() {
      var _this16 = this;

      if (!this.dynamicColumnsSettings) {
        return;
      }

      var columnSettings = this.columnSettings;
      var dataSource = this.dataSource || [];
      var _this$dynamicColumnsS = this.dynamicColumnsSettings,
          title = _this$dynamicColumnsS.title,
          data = _this$dynamicColumnsS.data,
          columns = _this$dynamicColumnsS.columns,
          index = _this$dynamicColumnsS.index;
      var dynamicCount = Math.max.apply(Math, _toConsumableArray(dataSource.map(function (r) {
        return (r[data] || []).length || 0;
      })));

      if (dynamicCount <= 0) {
        return;
      }

      var colspan = columns.length;
      var nestedHeaders = [];
      var beforeColumns = columnSettings.slice(0, index + 1);
      var afterColumns = columnSettings.slice(index + 1);

      for (var i = 0; i < beforeColumns.length; i++) {
        nestedHeaders.push("");
      }

      columnSettings = beforeColumns;

      var _loop3 = function _loop3(_i2) {
        columnSettings = columnSettings.concat(columns.map(function (c) {
          var column = _objectSpread2({}, c, {
            data: "".concat(data, ".").concat(_i2, ".").concat(c.data)
          });

          if (!column.editor) column.editor = false;

          if (!column.validator) {
            var validator = _this16.createDefaultValidator(column);

            if (validator) {
              column.validator = validator;
            }
          }

          return column;
        }));
        nestedHeaders.push({
          label: title({
            source: dataSource,
            index: _i2,
            data: data
          }),
          colspan: colspan
        });
      };

      for (var _i2 = 0; _i2 < dynamicCount; _i2++) {
        _loop3(_i2);
      }

      columnSettings = columnSettings.concat(afterColumns);

      for (var _i3 = 0; _i3 < afterColumns.length; _i3++) {
        nestedHeaders.push("");
      }

      columnSettings.forEach(function (column) {
        if (!column.width && column.__width) {
          column.width = column.__width;
        }

        if (!column.data) {
          column.data = "$".concat(column.text);
        }
      });
      return {
        columns: columnSettings,
        nestedHeaders: [nestedHeaders, new Array(columnSettings.length).fill("")]
      };
    },
    addDynamicColumnsHook: function addDynamicColumnsHook() {
      var _this17 = this;

      var hookHandle = function hookHandle() {
        var settings = _this17.handleDynamicColumnsHook();

        if (settings) {
          _this17.hotInstance.updateSettings(settings);
        }

        _this17.hotInstance.removeHook("afterLoadData", hookHandle);
      };

      this.hotInstance.addHook("afterLoadData", hookHandle);
    },
    addCalculateHook: function addCalculateHook() {
      var _this18 = this;

      this.hotInstance.addHook("afterChange", function (changes, source) {
        if (source === "caculate" || source === "loadData" || !changes || !changes.length || changes[0][1] === CHECK_COLUMN_NAME) {
          return;
        }

        var _changes$ = _slicedToArray(changes[0], 1),
            row = _changes$[0];

        var columns = _this18.hotInstance.getSettings().columns || [];
        var needCalculateColumns = columns.filter(function (c) {
          return c.calculate;
        });
        var dataSource = _this18.dataSource;
        var record = dataSource[row];
        var calculateChanges = [];

        if (!record) {
          return;
        }

        needCalculateColumns.forEach(function (column) {
          var field = column.data;
          if (!field) return;
          var fieldPath = field.split(".");
          var result;

          try {
            result = column.calculate({
              record: record,
              fieldPath: fieldPath
            });

            if (result === Handsontable.helper.getProperty(record, field)) {
              return;
            }

            calculateChanges.push([row, field, result]);
          } catch (e) {
            console.warn(e);
          }
        });

        if (calculateChanges.length) {
          _this18.hotInstance.setDataAtRowProp(calculateChanges, "caculate");
        }
      });
    },
    groupDataHandle: function groupDataHandle(data) {
      var _this19 = this;

      var layout = this.currentLayout;
      if (!layout || !layout["groupColumns"] || layout["groupColumns"].length === 0) return data;
      var groupColumns = layout["groupColumns"];

      var handleDataFunc = function handleDataFunc(handleData, field) {
        var medium = new Map();
        handleData.forEach(function (rowData) {
          if (!medium.has(rowData[field])) medium.set(rowData[field], []);
          medium.get(rowData[field]).push(rowData);
        });
        return medium;
      };

      var createGroupRecord = function createGroupRecord(children) {
        var record = {};

        if (_this19.hotSettings["groupSummary"] && typeof _this19.hotSettings["groupSummary"] === "function") {
          record = _this19.hotSettings["groupSummary"]({
            children: children
          });
          if (!record) record = {};
        }

        _this19.getColumnSettings().forEach(function (col) {
          if (!record[col.data]) record[col.data] = "";
        });

        return record;
      };

      var func = function func(i, recursionData) {
        var processResult = [];
        if (i >= groupColumns.length) return false;
        var field = groupColumns[i]["field"];
        var processData = handleDataFunc(recursionData, field);
        i++;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = processData.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;
            var groupRecord = createGroupRecord(processData.get(key));
            groupRecord[GROUP_RECORD_FLAG_NAME] = true;
            groupRecord[GROUP_RECORD_FIELD_FLAG_NAME] = field;
            groupRecord[field] = key;
            groupRecord["rowStatus"] = 2; // 添加状态，防止分组表格时被过滤数据

            if (_this19.showSelection) groupRecord[CHECK_COLUMN_NAME] = false;
            var ary = processData.get(key);

            if (i < groupColumns.length) {
              groupRecord[CHILDREN_RECORD_NAME] = func(i, ary);
            } else {
              groupRecord[CHILDREN_RECORD_NAME] = ary;
            }

            processResult.push(groupRecord);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return processResult;
      };

      return func(0, data);
    },
    prepareData: function prepareData(data) {
      var _this20 = this;

      var func = function func(d, summaryRow) {
        return _this20.summaryPosition === "first" ? [summaryRow].concat(d) : d.concat([summaryRow]);
      };

      return new Promise(function (resolve, reject) {
        if (!Array.isArray(data)) data = [];
        if (_this20.showSelection) data.forEach(function (record) {
          return record[CHECK_COLUMN_NAME] = !!record[CHECK_COLUMN_NAME];
        });
        if (_this20.groupView) data = _this20.groupDataHandle(data);

        if (_this20.summaryData && typeof _this20.summaryData === "function") {
          _this20.summaryData().then(function (summaryRow) {
            if (!summaryRow) summaryRow = {};
            summaryRow[SUMMARY_ROW_FLAG_NAME] = true;
            resolve(func(data, summaryRow));
          })["catch"](function (o) {
            return reject(o);
          });
        } else if (_this20.hasSummary && data.length) {
          resolve(func(data, {
            __SUMMARY_ROW: true,
            rowStatus: 2
          }));
        } else {
          resolve([].concat(data));
        }
      });
    },
    loadData: function loadData(data) {
      this.sortNames = [];
      this.sortDirections = [];
      this.error = {};
      this.renderData(data);
    },
    renderData: function renderData(data) {
      var _this21 = this;

      this.prepareData(data).then(function (data) {
        _this21.finalData = data;

        var mergeCells = _this21.getMergeCells();

        var settings = mergeCells ? {
          mergeCells: mergeCells
        } : _this21.settings;

        var dynamicSettings = _this21.handleDynamicColumnsHook();

        if (dynamicSettings) Object.assign(settings, dynamicSettings);

        _this21.updateSettings(settings);

        if (_this21.hasSummary) _this21.resetSummary();
        setTimeout(function () {
          if (_this21.hotInstance.isDestroyed) {
            return;
          }

          var pluginFilters = _this21.hotInstance.getPlugin("filters");

          if (pluginFilters && pluginFilters.enabled) pluginFilters.filter(); // 改由table组件触发

          if (_this21.settings && _this21.settings.scrollAutoHeight && _this21.$el) {
            if (_this21.finalData.length) {
              // 滚动条位置自适应数据高度
              if (_this21.$el.getElementsByClassName("wtHider")) {
                var height = _this21.$el.getElementsByClassName("wtHider")[0].clientHeight; // 表格是否有设置高度


                if (_this21.hotSettings.originalHeight) {
                  _this21.settings.height = _this21.hotSettings.originalHeight + 10;
                } else {
                  _this21.settings.height = height + 10;
                } // const parentHei =
                //   this.getFinalHeight(this.$el.parentElement) ===
                //   this.hotSettings.height + 10
                //     ? this.getFinalHeight(this.$el.parentElement.parentElement)
                //     : this.getFinalHeight(this.$el.parentElement);
                // const originalHeight =
                //   this.hotSettings.height && this.hotSettings.originalHeight
                //     ? this.hotSettings.originalHeight
                //     : parentHei;
                // if (height < originalHeight) {
                //   this.settings.height = height + 10;
                // } else {
                //   this.settings.height = originalHeight;
                // }

              }
            } else {
              var _height = _this21.$el.getElementsByClassName("wtHider")[0].clientHeight;

              _this21.settings.height = _height + 10;
            }

            _this21.updateSettings(_this21.settings);
          }
        }, 1);
      });
    },
    isSummaryRow: function isSummaryRow(record) {
      if (!this.hasSummary) return false;
      if (_typeof(record) !== "object") record = this.getRecord(record);
      return record && record[SUMMARY_ROW_FLAG_NAME];
    },
    toggleAll: function toggleAll(checked) {
      var _this22 = this;

      var nestedRowsPlugin = this.hotInstance.getPlugin("nestedRows");
      var data = nestedRowsPlugin && nestedRowsPlugin.dataManager ? nestedRowsPlugin.dataManager.cache.rows : this.finalData;
      data && data.forEach(function (record, i) {
        if (_this22.isSummaryRow(record)) return;

        if (_this22.hotInstance.hasHook("assertFilter")) {
          var filtered = _this22.hotInstance.runHooks("assertFilter", i);

          if (filtered == true) return true;
        } // const trimRowsPlugin = this.hotInstance.getPlugin('trimRows');
        // if (!trimRowsPlugin || !trimRowsPlugin.trimmedRows.includes(i))


        record[CHECK_COLUMN_NAME] = checked;
      }); // this.updateSettings();

      this.hotInstance.render();
      this.$emit("selectionChange", {
        isAll: true,
        checked: checked
      });
    },
    toggleColunmAll: function toggleColunmAll(checked, col) {
      var _this23 = this;
      var defaultHiddenColumns = this.defaultHiddenColumns;
      var columnSettings = JSON.parse(JSON.stringify(this.columnSettings));
      var length = columnSettings.length;

      for (var i = length - 1; i >= 0; i--) {
        if (defaultHiddenColumns.indexOf(i) > -1) {
          columnSettings.splice(i, 1);
        }
      }

      var settings = columnSettings[col];
      var nestedRowsPlugin = this.hotInstance.getPlugin("nestedRows");
      var data = nestedRowsPlugin && nestedRowsPlugin.dataManager ? nestedRowsPlugin.dataManager.cache.rows : this.finalData;
      data && data.forEach(function (record, i) {
        if (_this23.isSummaryRow(record)) return;

        if (_this23.hotInstance.hasHook("assertFilter")) {
          var filtered = _this23.hotInstance.runHooks("assertFilter", i);

          if (filtered == true) return true;
        }

        if (checked) {
          record[settings.data] = settings.checkedTemplate ? settings.checkedTemplate : true;
        } else {
          record[settings.data] = settings.uncheckedTemplate ? settings.uncheckedTemplate : false;
        }
      });
      this.hotInstance.render();
      this.$emit("colunmSelectionChange", {
        colunm: settings.data,
        checked: checked
      });
    },
    selectRows: function selectRows(rows, checked) {
      if (checked === undefined || checked === null) checked = true;
      rows.forEach(function (row) {
        row[CHECK_COLUMN_NAME] = checked;
      });
      this.hotInstance.render();
    },
    selectionChange: function selectionChange(row, checked) {
      var _this24 = this;

      var nestedRowsPlugin = this.hotInstance.getPlugin("nestedRows");

      if (this.settings.checkStrict !== false && nestedRowsPlugin && nestedRowsPlugin.dataManager) {
        var nodeInfo = nestedRowsPlugin.dataManager.cache.nodeInfo;
        var currentRecord = nestedRowsPlugin.dataManager.cache.rows[row];

        var childrenFunc = function childrenFunc(r) {
          if (r["__children"]) {
            r["__children"].forEach(function (record) {
              var node = nodeInfo.get(record);

              if (node) {
                var filtered = _this24.hotInstance.runHooks("assertFilter", node.row);

                record[CHECK_COLUMN_NAME] = filtered == true ? false : checked;
              }

              childrenFunc(record);
            });
          }
        };

        childrenFunc(currentRecord);
        var node = nodeInfo.get(currentRecord);

        if (node) {
          while (node && node.parent && node.parent["__children"]) {
            var ary = node.parent["__children"].filter(function (item) {
              return !item[CHECK_COLUMN_NAME];
            });
            var filtered = this.hotInstance.runHooks("assertFilter", node.row);
            node.parent[CHECK_COLUMN_NAME] = filtered == true ? false : ary.length === 0;
            node = nodeInfo.get(node.parent);
          }
        }

        this.hotInstance.render();
      }
    },
    updateSettings: function updateSettings() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var settings = _objectSpread2({
        data: this.finalData
      }, options);

      if (settings.columns) {
        this.buildColumns(settings, []);
      }

      this.hotInstance.deselectCell();
      var trimRowsPlugin = this.hotInstance.getPlugin("trimRows");
      if (trimRowsPlugin) trimRowsPlugin.untrimAll();
      var nestedRowsPlugin = this.hotInstance.getPlugin("nestedRows");

      if (nestedRowsPlugin && nestedRowsPlugin.dataManager) {
        var dataManager = nestedRowsPlugin.dataManager;
        dataManager.data = [];
        dataManager.rewriteCache();
      }

      this.hotInstance.updateSettings(settings);

      if (nestedRowsPlugin && nestedRowsPlugin.collapsingUI && this.settings.defaultCollapsed) {
        setTimeout(function () {
          nestedRowsPlugin.collapsingUI.collapseAll();
        }, 100);
      }
    },
    isSelectAll: function isSelectAll() {
      var _this25 = this;

      var trimRowsPlugin = this.hotInstance.getPlugin("trimRows");
      var nestedRowsPlugin = this.hotInstance.getPlugin("nestedRows");

      if (nestedRowsPlugin && nestedRowsPlugin.dataManager) {
        return this.showSelection && nestedRowsPlugin.dataManager.cache.rows.filter(function (record, i) {
          if (_this25.isSummaryRow(record)) return false;
          if (trimRowsPlugin && trimRowsPlugin.trimmedRows.includes(i)) return false;

          if (_this25.hotInstance.hasHook("assertFilter")) {
            var filtered = _this25.hotInstance.runHooks("assertFilter", i);

            if (filtered == true) return true;
          }

          return record[CHECK_COLUMN_NAME] === false;
        }).length === 0;
      } else if (this.showSelection) {
        var len = this.finalData.filter(function (record, i) {
          if (_this25.isSummaryRow(record)) return false;
          if (trimRowsPlugin && trimRowsPlugin.trimmedRows.includes(i)) return false;

          if (_this25.hotInstance.hasHook("assertFilter")) {
            var filtered = _this25.hotInstance.runHooks("assertFilter", i);

            if (filtered == true) return true;
          }

          return record[CHECK_COLUMN_NAME] === false;
        }).length;
        return len === 0;
      }

      return false;
    },
    isColunmSelectAll: function isColunmSelectAll(col) {
      var defaultHiddenColumns = this.defaultHiddenColumns;
      var columnSettings = JSON.parse(JSON.stringify(this.columnSettings));
      var length = columnSettings.length;

      for (var i = length - 1; i >= 0; i--) {
        if (defaultHiddenColumns.indexOf(i) > -1) {
          columnSettings.splice(i, 1);
        }
      }

      var settings = columnSettings[col];
      var checked = this.finalData.reduce(function (res, record, i) {
        if (settings.checkedTemplate) {
          if (record[settings.data] === settings.checkedTemplate) {
            return res && true;
          }
        } else if (settings.uncheckedTemplate) {
          if (record[settings.data] === settings.uncheckedTemplate) {
            return res && false;
          }
        } else if (record[settings.data]) {
          return res && true;
        } else {
          return res && false;
        }
      }, true);
      return checked;
    },
    getSelectionColumn: function getSelectionColumn() {
      var _this26 = this;

      return {
        data: CHECK_COLUMN_NAME,
        field: CHECK_COLUMN_NAME,
        type: "checkbox",
        editor: false,
        width: this.selectionColumnWidth || 60,
        checkedTemplate: true,
        uncheckedTemplate: false,
        readOnly: false,
        className: this.treeView ? "htLeft ht-checkbox-column" : "htCenter ht-checkbox-column",
        multiColumnSorting: {
          // 复选框列禁用排序
          indicator: false,
          headerAction: false,
          compareFunctionFactory: function compareFunctionFactory() {
            return function comparator() {
              return 0;
            };
          }
        },
        renderer: function renderer(instance, td, row, col, prop, value, cellProperties) {
          if (prop === CHECK_COLUMN_NAME) {
            var physicalRow = _this26.hotInstance.toPhysicalRow(row);

            if (_this26.isSummaryRow(physicalRow)) {
              td.innerHTML = "&nbsp;";
            } else if (_this26.treeView) {
              Handsontable.renderers.getRenderer("treeCheckbox").apply(_this26, [instance, td, row, col, prop, value, cellProperties]);
            } else {
              Handsontable.renderers.CheckboxRenderer.apply(_this26, [instance, td, row, col, prop, value, cellProperties]);
            }
          }

          return td;
        },
        columnSorting: {
          indicator: false,
          headerAction: false
        }
      };
    },
    getRecord: function getRecord(row) {
      var nestedRowsPlugin = this.hotInstance.getPlugin("nestedRows");

      if (nestedRowsPlugin && nestedRowsPlugin.dataManager) {
        return nestedRowsPlugin.dataManager.cache.rows[row];
      } else {
        return this.finalData[row];
      }
    },
    resetSummary: function resetSummary() {
      var plugin = this.hotInstance.getPlugin("columnSummary");
      if (plugin) plugin.endpoints.refreshAllEndpoints();
    },
    doSort: function doSort(newSortName, newSortDirection, multi) {
      var oldSortDirection,
          sortNames = this.sortNames,
          sortDirections = this.sortDirections;
      var currentSortConfig = {
        sortNames: [].concat(sortNames),
        sortDirections: [].concat(sortDirections)
      };

      if (multi) {
        var index = this.sortNames.indexOf(newSortName);

        if (index >= 0) {
          oldSortDirection = sortDirections[index];

          if (oldSortDirection === newSortDirection) {
            sortNames.splice(index, 1);
            sortDirections.splice(index, 1);
          } else {
            sortDirections[index] = newSortDirection;
          }
        } else {
          sortNames.push(newSortName);
          sortDirections.push(newSortDirection);
        }
      } else {
        sortNames = [newSortName];
        sortDirections = [newSortDirection];
      }

      this.sortNames = sortNames;
      this.sortDirections = sortDirections;
      if (this.hotSettings.frontSorting) this._doFrontEndSort();
      this.$emit("afterColumnSort", {
        currentSortConfig: currentSortConfig,
        destinationSortConfigs: {
          sortNames: [].concat(sortNames),
          sortDirections: [].concat(sortDirections)
        }
      });
    },

    /**
     * 生成前端排序比较方法
     * @param {string[]} sortNames 排序字段数组
     * @param {string[]} sortDirections 排序方向数组
     * @returns {Function(a: Object, b: Object): number}
     */
    _createSortFunc: function _createSortFunc(sortNames, sortDirections) {
      sortNames = sortNames || [];
      sortDirections = sortDirections || [];
      return function (a, b) {
        var len = sortNames.length;
        var ret = 0;
        var sortName, sortDirection, va, vb;

        for (var i = 0; i < len; i++) {
          sortName = sortNames[i];
          sortDirection = sortDirections[i];
          va = a.record ? a.record[sortName] : a[sortName];
          vb = b.record ? b.record[sortName] : b[sortName];
          va = !va && va !== 0 ? "" : va;

          if (va === "" && typeof vb === "number") {
            va = -Infinity;
          }

          vb = !vb && vb !== 0 ? "" : vb;

          if (vb === "" && typeof va === "number") {
            vb = -Infinity;
          }

          if (va > vb) {
            ret = sortDirection === SORT_DIRECTION.ASC ? 1 : -1;
            break;
          } else if (va < vb) {
            ret = sortDirection === SORT_DIRECTION.ASC ? -1 : 1;
            break;
          }
        }

        return ret;
      };
    },

    /**
     * 执行前端排序
     */
    _doFrontEndSort: function _doFrontEndSort() {
      if (this.finalData.length === 0) return;

      var sortFunc = this._createSortFunc(this.sortNames, this.sortDirections);

      var summaryRecords, summaryRecord;

      if (this.hasSummary) {
        if (this.summaryPosition === "first") {
          summaryRecords = this.finalData.splice(0, 1);
        } else {
          summaryRecords = this.finalData.splice(this.finalData.length - 1, 1);
        }

        if (summaryRecords && summaryRecords.length > 0) summaryRecord = summaryRecords[0];
      }

      this.finalData.sort(sortFunc);

      if (this.hasSummary) {
        if (this.summaryPosition === "first") {
          this.finalData.splice(0, 0, summaryRecord);
        } else {
          this.finalData.push(summaryRecord);
        }
      }

      this.updateSettings();
    },

    /**
     * 获取列排序信息
     */
    getColumnSortingInfo: function getColumnSortingInfo() {
      var hotInstance = this.hotInstance;
      var columnSettings = this.getColumnSettings();
      var plugin = hotInstance.getPlugin("multiColumnSorting");

      if (!plugin) {
        return null;
      }

      var states = plugin.columnStatesManager.sortedColumnsStates || [];
      return states;
    },

    /**
     * 获取可见列
     */
    getVisibleColumns: function getVisibleColumns() {
      var hotInstance = this.hotInstance;
      var hiddenColumnsPlugin = hotInstance.getPlugin("hiddenColumns");
      var visibleColumns = [];
      hotInstance.getColHeader().forEach(function (title, i) {
        if (hiddenColumnsPlugin && hiddenColumnsPlugin.isEnabled() && hiddenColumnsPlugin.isHidden(i)) {
          return;
        }

        var tmpEl = document.createElement("div");
        tmpEl.innerHTML = title;
        var text = tmpEl.innerText;
        tmpEl.remove();
        visibleColumns.push({
          title: text,
          field: hotInstance.colToProp(i),
          width: hotInstance.getColWidth(i)
        });
      });
      return visibleColumns;
    },

    /**
     * 开始配置布局
     */
    startSettingLayout: function startSettingLayout() {
      var layoutInfo = this.getCurrentLayoutInfo();
      if (this.showSelection) layoutInfo.fixedColumnsLeft--;
      if (this.groupView) this.$refs.groupTableLayoutTransfer.handleOpenDialog(layoutInfo);else this.$refs.tableLayoutTransfer.handleOpenDialog(layoutInfo);
    },

    /**
     * 清除所有过滤条件
     */
    clearAllFilters: function clearAllFilters() {
      var pluginFilters = this.hotInstance.getPlugin("filters");
      if (pluginFilters) pluginFilters.clearConditions();
      this.renderData(this.dataSource);
    },

    /**
     * 获取当前表格布局信息
     */
    getCurrentLayoutInfo: function getCurrentLayoutInfo() {
      var hotInstance = this.hotInstance,
          originColumnSettings = this.columnSettings;
      var hotSettings = hotInstance.getSettings();
      var sortingInfo = this.getColumnSortingInfo() || [];
      var colSettingsKey = this.$props.colSettingsKey;
      var fixedColumnsLeft = hotSettings.fixedColumnsLeft,
          columnSettings = hotSettings.columns;
      var allColumns = originColumnSettings.map(function (column, i) {
        return {
          title: column.text,
          field: column.data,
          width: column.width || 100
        };
      });

      var getDiff = function getDiff(param1, param2) {
        var allFieldList = param1.map(function (item) {
          return item["field"];
        });
        var partFieldList = param2.map(function (item) {
          return item["field"];
        });
        var diffFieldList = [];

        for (var i = 0; i < allFieldList.length; i++) {
          if (partFieldList.includes(allFieldList[i])) continue;
          diffFieldList.push(param1[i]);
        }

        return diffFieldList;
      };

      var visibleColumns = this.getVisibleColumns(); // this.currentLayout ? this.currentLayout['visibleColumns'] : allColumns;

      var groupColumns = this.currentLayout ? this.currentLayout["groupColumns"] : [];
      var columnSorting = sortingInfo.map(function (s) {
        var column = columnSettings[s.column];

        if (!column) {
          return;
        }

        var field = column.data;
        var sortOrder = s.sortOrder;
        return {
          field: field,
          sortOrder: sortOrder
        };
      });
      allColumns = allColumns.filter(function (column) {
        return column.field !== CHECK_COLUMN_NAME;
      });
      visibleColumns = visibleColumns.filter(function (column) {
        return column.field !== CHECK_COLUMN_NAME;
      });
      if (groupColumns) groupColumns = groupColumns.filter(function (column) {
        return column.field !== CHECK_COLUMN_NAME;
      });
      var tempColumns = getDiff(allColumns, visibleColumns);
      allColumns = visibleColumns.concat(tempColumns);
      var layoutInfo = {
        allColumns: allColumns,
        visibleColumns: visibleColumns,
        columnSorting: columnSorting,
        fixedColumnsLeft: fixedColumnsLeft,
        colSettingsKey: colSettingsKey,
        callback: this.updateLayoutSetting,
        currentLayoutName: this.currentLayoutName
      };
      if (this.groupView) layoutInfo["groupColumns"] = groupColumns;
      return layoutInfo;
    },
    createLayoutSettingData: function createLayoutSettingData(_ref4) {
      var _this27 = this;

      var visibleColumns = _ref4.visibleColumns,
          fixedColumnsLeft = _ref4.fixedColumnsLeft,
          columnSorting = _ref4.columnSorting;
      var sortingInfo = [];
      (columnSorting || []).forEach(function (s) {
        var index = visibleColumns.findIndex(function (c) {
          return c.field === s.field;
        });

        if (index < 0) {
          return;
        }

        sortingInfo.push({
          column: index,
          sortOrder: s.sortOrder
        });
      });
      var newColumnSettings = (visibleColumns || []).map(function (col) {
        var column = _this27.columnSettings.find(function (c) {
          return c.data === col.field;
        });

        if (!column) {
          return null;
        }

        column.width = col.width;
        return column;
      });
      if (this.showSelection && newColumnSettings) newColumnSettings.splice(0, 0, this.getSelectionColumn());
      var result = {
        columns: newColumnSettings,
        fixedColumnsLeft: fixedColumnsLeft
      };

      if (sortingInfo && sortingInfo.length > 0) {
        result["multiColumnSorting"] = {
          initialConfig: sortingInfo
        };
      }

      return result;
    },

    /**
     * 执行更新布局
     */
    updateLayoutSetting: function updateLayoutSetting(_ref5) {
      var groupColumns = _ref5.groupColumns,
          visibleColumns = _ref5.visibleColumns,
          fixedColumnsLeft = _ref5.fixedColumnsLeft,
          columnSorting = _ref5.columnSorting,
          layoutName = _ref5.layoutName,
          type = _ref5.type;

      if (type === "Save" || type == "Submit") {
        layoutName = this.currentLayoutName;
      }

      if (this.showSelection) fixedColumnsLeft++;
      this.currentLayoutName = layoutName;
      this.currentLayout = {
        groupColumns: groupColumns,
        visibleColumns: visibleColumns,
        fixedColumnsLeft: fixedColumnsLeft,
        columnSorting: columnSorting,
        layoutName: layoutName
      };
      var settings = this.createLayoutSettingData({
        visibleColumns: visibleColumns,
        fixedColumnsLeft: fixedColumnsLeft,
        columnSorting: columnSorting
      });
      if (settings.columns) this.renderColumns = settings.columns;
      this.hotInstance.updateSettings(settings);
      this.renderData(this.dataSource); // 缓存到 localStorage

      if (type === "SaveAs" || type === "Save" || type === "Change") {
        var info = {
          visibleColumns: visibleColumns,
          fixedColumnsLeft: fixedColumnsLeft,
          columnSorting: columnSorting,
          layoutName: layoutName,
          t: +new Date()
        };
        if (groupColumns) info["groupColumns"] = groupColumns;
        utils.localStorageSet("Layouts.".concat(this.$props.colSettingsKey), info);
      }

      switch (type) {
        case "SaveAs":
          var _info = {
            visibleColumns: visibleColumns,
            columnSorting: columnSorting,
            fixedColumnsLeft: fixedColumnsLeft,
            colSettingsKey: this.$props.colSettingsKey,
            layoutName: layoutName
          };
          if (groupColumns) _info["groupColumns"] = groupColumns;
          this.saveAsLayout(_info);
          break;

        case "Save":
          var currentLayoutName = this.currentLayoutName,
              layoutSettingsList = this.layoutSettingsList;
          var data = {
            visibleColumns: visibleColumns,
            columnSorting: columnSorting,
            fixedColumnsLeft: fixedColumnsLeft,
            colSettingsKey: this.$props.colSettingsKey,
            layoutName: currentLayoutName
          };
          if (groupColumns) data["groupColumns"] = groupColumns;

          if (currentLayoutName) {
            var currentLayoutSetting = layoutSettingsList.find(function (s) {
              return s.layoutName === currentLayoutName;
            });

            if (!currentLayoutSetting) {
              break;
            }

            data["gridLayoutId"] = currentLayoutSetting.gridLayoutId;
          }

          this.saveLayout(data);
          break;

        default:
          break;
      }
    },

    /**
     * 重置布局
     */
    resetLayout: function resetLayout() {
      this.currentLayoutName = null;
      this.currentLayout = null;
      this.renderColumns = false;
      utils.localStorageRemove("Layouts.".concat(this.$props.colSettingsKey));
      this.hotInstance.updateSettings({
        columns: this.getColumns(),
        fixedColumnsLeft: this.showSelection ? 1 : 0
      });
      if (this.dataSource && this.dataSource.length) this.renderData(this.dataSource);
    },
    getColumns: function getColumns() {
      var _this28 = this;

      return this.columnSettings.filter(function (__, i) {
        return _this28.defaultHiddenColumns.indexOf(i) === -1;
      });
    },
    setRequestCtx: function setRequestCtx() {
      if (!this.requestCtx) return;
      if (!utils.config) utils.config = {};
      utils.config.ctx = this.requestCtx;
    },

    /**
     * 删除布局
     */
    removeCurrentLayout: function removeCurrentLayout() {
      var _this29 = this;

      var currentLayoutName = this.currentLayoutName,
          layoutSettingsList = this.layoutSettingsList;

      var _this = this;

      var currentLayoutSettings = layoutSettingsList.find(function (s) {
        return s.layoutName === currentLayoutName;
      });
      this.setRequestCtx();
      return utils.deleteLayoutSettings(Object.assign({}, currentLayoutSettings, {
        colSettingsKey: this.$props.colSettingsKey
      })).then(function () {
        delete _this.renderColumns;

        _this._getLayoutSettingsList();

        _this.resetLayout();

        _this.currentLayout = null;

        _this.renderData(_this.dataSource);
      })["catch"](function (e) {
        // console.error(e);
        _this29.$message({
          type: "error",
          message: e && e.toString()
        });
      });
    },

    /** 布局另存为 */
    saveAsLayout: function saveAsLayout(params) {
      var _this30 = this;

      if (!this.groupView) delete params["groupColumns"];
      this.setRequestCtx();
      return utils.saveAsLayoutSettings(params).then(function () {
        _this30._getLayoutSettingsList();
      })["catch"](function (e) {
        console.error(e);

        _this30.$message({
          type: "error",
          message: e && e.toString()
        });
      });
    },

    /** 保存布局 */
    saveLayout: function saveLayout(params) {
      var _this31 = this;

      if (!this.groupView) delete params["groupColumns"];
      this.setRequestCtx();
      return utils.saveLayoutSettings(params).then()["catch"](function (e) {
        console.error(e);

        _this31.$message({
          type: "error",
          message: e && e.toString()
        });
      });
    },

    /**
     * 添加布局小齿轮
     */
    _addSettingsButton: function _addSettingsButton(index, th) {
      if (index !== 0) {
        return;
      }

      var innerSpan = th.querySelector("span");
      var button = document.createElement("button");

      button.onclick = function () {
        return false;
      };

      button.classList.add("el-icon-s-tools", "hot-layout-settings-button");
      innerSpan.append(button);
    },

    /**
     * 点击布局小齿轮
     */
    _onClickSettingsButton: function _onClickSettingsButton(event) {
      var target = event.target;

      if (!target.classList.contains("hot-layout-settings-button")) {
        return;
      }

      event.stopImmediatePropagation();
      this.startSettingLayout();
    },

    /**
     * 获取布局设置列表
     */
    _getLayoutSettingsList: function _getLayoutSettingsList() {
      var _this32 = this;

      this.setRequestCtx();
      utils.getLayoutSettingsList({
        colSettingsKey: this.$props.colSettingsKey
      }).then(function (list) {
        _this32.layoutSettingsList = list;
      })["catch"](function (e) {
        console.error(e);

        _this32.$message({
          type: "error",
          message: e && e.toString()
        });
      });
    },

    /**
     * 新增行
     */
    addRow: function addRow(record, pos) {
      if (!record) record = {};
      pos = !pos || isNaN(pos) ? 0 : parseInt(pos);
      this.dataSource.splice(pos, 0, record);
      this.renderData(this.dataSource);
    },

    /**
     * 默认校验器
     * @param value
     * @param callback
     * @param cellProperties
     */
    defaultValidator: function defaultValidator(value, callback, cellProperties) {
      var _this33 = this;

      var rules = this.groupedRules && this.groupedRules[cellProperties.prop];

      if (!rules) {
        callback(true);
        return;
      }

      var record = this.getRecord(cellProperties.row);
      record = _objectSpread2({}, record, _defineProperty({}, cellProperties.prop, value));
      this.$validate.transform(record, rules, this.combineName).then(function (transformedRules) {
        var validateRules = transformedRules[cellProperties.prop] || [];
        var times = 0;
        var errorMessageList = [];

        var clientCallback = function clientCallback(message) {
          times++;
          if (message) errorMessageList.push(message);

          if (times === validateRules.length) {
            var valid = errorMessageList.length === 0;
            callback(valid);
            var key = cellProperties.row + "_" + cellProperties.col;
            if (valid) delete _this33.error[key];else _this33.error[key] = errorMessageList;
          }
        };

        validateRules.forEach(function (validateRule) {
          return validateRule.validator(validateRule, value, clientCallback);
        });
      });
    },
    createDefaultValidator: function createDefaultValidator(column) {
      if (!this.groupedRules[column && column.data]) {
        return null;
      }

      return this.defaultValidator;
    },
    updateColumnValidator: function updateColumnValidator() {
      var _this34 = this;

      var columns = this.hotInstance.getSettings().columns || [];
      columns.forEach(function (c) {
        var validator = _this34.createDefaultValidator(c);

        if (validator) {
          c.validator = validator;
        } else {
          delete c.validator;
        }
      });
      this.hotInstance.updateSettings({
        columns: columns
      });
    },
    startEdit: function startEdit(row, col) {
      var self = this;
      self.hotInstance.selectCell(row, col);
      var activeEditor = this.hotInstance.getActiveEditor();

      var func = function func() {
        var selected = self.hotInstance.getSelected();
        var range = selected && selected[0] || [];
        var selectedRow = range[0];
        var selectedCol = range[1];

        if (selectedRow !== row || selectedCol !== col) {
          console.log("Selected cell has been changed. Start edit is cancel: ", row, col);
          return;
        }

        var physicalColumn = self.hotInstance.toPhysicalColumn(col);
        var columnSetting = self.getColumnSettingAtCol(physicalColumn);
        if (!columnSetting.editorName) return;
        var prop = self.hotInstance.colToProp(col); // const td = self.hotInstance.getCell(row, col);

        var td = null;
        var currentLayoutInfo = self.getCurrentLayoutInfo();
        var fixedColumnsLeft = self.showSelection ? currentLayoutInfo.fixedColumnsLeft - 1 : currentLayoutInfo.fixedColumnsLeft;

        if (fixedColumnsLeft > 0) {
          td = self.$el.querySelector(".ht_clone_left").querySelector(".current,.hightlight");
        } else {
          td = self.hotInstance.getCell(row, col);
        }

        var physicalRow = self.hotInstance.toPhysicalRow(row);
        var record = self.getRecord(physicalRow);
        var originalValue = record[prop];
        var cellProperties = self.hotInstance.getCellMeta(row, col);
        if (!td) return;
        var editor = self.editorCache.get(columnSetting.editorName);
        editor.enableFullEditMode();
        editor.prepare(row, col, prop, td, originalValue, cellProperties);
        editor.beginEditing(originalValue, {});

        if (fixedColumnsLeft > 0) {
          var tdPosition = td.getBoundingClientRect();
          editor.style["zIndex"] = 9999;
          editor.style["left"] = tdPosition.left + "px";
          editor.style["top"] = tdPosition.top + "px";
        }
      };

      if (activeEditor) {
        activeEditor.finishEditing(false, false, function () {
          setTimeout(function () {
            func();
          }, 10);
        });
      } else {
        // self.hotInstance.selectCell(row, col);
        func();
      }
    },
    finishEdit: function finishEdit(callback) {
      if (this.hotInstance.isDestroyed) {
        return;
      }

      var activeEditor = this.hotInstance.getActiveEditor();

      if (activeEditor) {
        if (callback && typeof callback === "function") {
          activeEditor.finishEditing(false, false, function () {
            callback();
          });
        } else {
          activeEditor.finishEditing();
        }
      } else if (callback && typeof callback === "function") {
        callback();
      }
    },
    validateRows: function validateRows(callback, rows) {
      if (!rows) {
        rows = [];
        var rowCount = this.hotInstance.countRows();
        var i = 0;

        while (i < rowCount) {
          rows.push(i);
          i++;
        }
      }

      this.hotInstance.validateRows(rows, function (valid) {
        callback(valid);
      });
    },
    validateCells: function validateCells(callback) {
      this.hotInstance.validateCells(function (valid) {
        callback(valid);
      });
    },
    validateColumns: function validateColumns(callback, columns) {
      this.hotInstance.validateColumns(columns, function (valid) {
        callback(valid);
      });
    },
    showErrorMessage: function showErrorMessage(x, y, message) {
      var messages = typeof message === "string" ? [message] : message;

      if (!this.errorMessageEl) {
        var errorMessageEl = document.createElement("div");
        errorMessageEl.className = "handsontable-tooltip el-tooltip__popper is-light";
        errorMessageEl.style.transformOrigin = "center top";
        errorMessageEl.style.zIndex = "9999";
        errorMessageEl.style.display = "none";
        var errorMessageContentEl = document.createElement("span");
        errorMessageContentEl.className = "hot-error-message-content";
        var errorArrowEl = document.createElement("div");
        errorArrowEl.setAttribute("x-arrow", "");
        errorArrowEl.className = "popper__arrow";
        errorArrowEl.style.left = "20px";
        errorMessageEl.appendChild(errorMessageContentEl);
        errorMessageEl.appendChild(errorArrowEl);
        document.body.appendChild(errorMessageEl);
        this.errorMessageEl = errorMessageEl;
      }

      this.errorMessageEl.getElementsByClassName("hot-error-message-content").item(0).innerHTML = messages.join("<br />");
      this.errorMessageEl.style.display = "";
      this.errorMessageEl.style.left = x + "px";
      this.errorMessageEl.style.top = y + "px";
    },
    hideErrorMessage: function hideErrorMessage() {
      if (this.errorMessageEl) this.errorMessageEl.style.display = "none";
    },
    selectCell: function selectCell(row, col) {
      this.hotInstance.selectCell(row, col);
    },
    deselectCell: function deselectCell() {
      this.hotInstance.deselectCell();
    },
    resizeTo: function resizeTo(width, height) {
      if (!this.hotInstance) return;
      var sizeObj = {};
      if (width) sizeObj["width"] = width;
      if (height) sizeObj["height"] = height;

      if (!width && !height) {
        sizeObj["width"] = this.getFinalWidth(this.$el.parentElement);
      }

      this.hotInstance.updateSettings(sizeObj);
    },
    scrollListener: function scrollListener(target) {
      var _this35 = this;

      var handler = function handler(e) {
        var target = e.target;

        if (target.contains(_this35.$el)) {
          _this35.finishEdit(); // 结束编辑
          // 关闭下拉过滤界面


          var dropdownMenuPlugin = _this35.hotInstance.getPlugin("DropdownMenu");

          dropdownMenuPlugin && dropdownMenuPlugin.close();
        }
      };

      document.addEventListener("scroll", handler, true);

      this.offScrollListener = function () {
        return document.removeEventListener("scroll", handler, true);
      };
    },
    resizeListener: function resizeListener(obj) {
      var _this36 = this;

      var listenHeight = obj.height;
      var listenWidth = obj.width;

      if (!listenHeight && !listenWidth) {
        return;
      }

      var handler = Handsontable.helper.debounce(function () {
        var parentElement = _this36.$el.parentElement;

        var parentWidth = _this36.getFinalWidth(parentElement);

        var parentHeight = _this36.getFinalHeight(parentElement);

        var currentWidth = _this36.$el.clientWidth;
        var currentHeight = _this36.$el.clientHeight;
        var sizeObj = {};

        if (listenWidth && parentWidth !== currentWidth) {
          sizeObj.width = parentWidth;
        }

        if (listenHeight && parentHeight !== currentHeight) {
          sizeObj.height = parentHeight;
        } else if (_this36.settings.scrollAutoHeight && _this36.$el) {
          var height = _this36.$el.getElementsByClassName("wtHider")[0].clientHeight;

          sizeObj.height = height + 10;
        }

        _this36.hotInstance.updateSettings(sizeObj);
      }, 500);
      window.addEventListener("resize", handler);

      this.offResizeListener = function () {
        return window.removeEventListener("resize", handler);
      };
    },
    render: function render() {
      this.hotInstance.render();
    },
    getFinalWidth: function getFinalWidth(el) {
      var elStyle = window.getComputedStyle(el);
      return el.clientWidth - (parseInt(elStyle.borderLeftWidth) || 0) - (parseInt(elStyle.borderRightWidth) || 0) - (parseInt(elStyle.paddingLeft) || 0) - (parseInt(elStyle.paddingRight) || 0);
    },
    getFinalHeight: function getFinalHeight(el) {
      var elStyle = window.getComputedStyle(el);
      return el.clientHeight - (parseInt(elStyle.borderTopWidth) || 0) - (parseInt(elStyle.borderBottomWidth) || 0) - (parseInt(elStyle.paddingTop) || 0) - (parseInt(elStyle.paddingBottom) || 0);
    },
    // 结束拖选
    finishDragCheck: function finishDragCheck(start, end) {
      var startIndex = start,
          // this.hotInstance.toPhysicalRow(start),
      endIndex = end,
          //this.hotInstance.toPhysicalRow(end),
      pluginNestedRow = this.hotInstance.getPlugin("nestedRows"),
          rows = [],
          endRecord = this.getRecord(endIndex),
          nodeInfo = pluginNestedRow && pluginNestedRow.dataManager && pluginNestedRow.dataManager.cache && pluginNestedRow.dataManager.cache.nodeInfo,
          endRecordChecked = endRecord["$$checked"];

      if (pluginNestedRow && pluginNestedRow.dataManager !== null && pluginNestedRow.dataManager.cache && pluginNestedRow.dataManager.cache !== null && pluginNestedRow.dataManager.cache.rows && pluginNestedRow.dataManager.cache.rows.length > 0) {
        rows = pluginNestedRow.dataManager.cache.rows;
      } else {
        rows = this.finalData;
      }

      for (var i = startIndex; i <= endIndex; i++) {
        if (this.hotInstance.hasHook("assertFilter")) {
          var filtered = this.hotInstance.runHooks("assertFilter", i);
          if (filtered == true) continue;
        }

        rows[i]["$$checked"] = !rows[i]["$$checked"];
      }

      if (endRecord["__children"] && endRecord["__children"].length > 0 && nodeInfo) {
        var childrenFunc = function childrenFunc(r) {
          if (r["__children"]) {
            r["__children"].forEach(function (record) {
              var node = nodeInfo.get(record);

              if (node) {
                record[CHECK_COLUMN_NAME] = !endRecordChecked;
              }

              childrenFunc(record);
            });
          }
        };

        childrenFunc(endRecord);
      }

      this.updateSettings();
      this.$emit("selectionChange", {
        isAll: false
      });
    },
    // 获取容器或父容器的z-index
    getZindex: function getZindex(element) {
      if (element.style.zIndex === "") {
        if (element.parentElement) {
          return this.getZindex(element.parentElement);
        } else {
          return "9999";
        }
      } else {
        return element.style.zIndex;
      }
    },

    /** 根据 rulesKey 加载校验规则 */
    getRulesByKey: function getRulesByKey() {
      var _this37 = this;

      if (!this.rulesKey) {
        return Promise.resolve();
      }

      return this.$validationHolder.getRules(this.rulesKey).then(function (rules) {
        return _this37.ecRules = rules;
      });
    },
    addRefToValidationGroup: function addRefToValidationGroup() {
      if (!this.validationGroup) {
        return;
      }

      this.validationGroup.addRef(this, "hotTable");
    },
    removeRefFromValidationGroup: function removeRefFromValidationGroup() {
      if (!this.validationGroup) {
        return;
      }

      this.validationGroup.removeRef(this, "hotTable");
    },
    transformColumns: function transformColumns(columns) {
      this.$transformColumns = _toConsumableArray(columns);
      this.renderTransformcolumns();
    },
    renderTransformcolumns: function renderTransformcolumns() {
      var visibleColumns = this.getVisibleColumns();
      var columnSettings = this.columnSettings;
      var transformColumns = (this.$transformColumns || []).filter(function (c) {
        return !c.nestedHeaderName;
      });
      var transformNestedHeaders = (this.$transformColumns || []).filter(function (c) {
        return c.nestedHeaderName;
      });
      var resultColumns = [];
      columnSettings.forEach(function (columnSetting) {
        var transformColumn = transformColumns.find(function (tc) {
          return tc.field === columnSetting.data;
        });

        if (transformColumn) {
          if (transformColumn.title !== undefined) {
            columnSetting.text = transformColumn.title;
          }

          if (transformColumn.show) {
            resultColumns.push(columnSetting);
          }

          return;
        }

        if (visibleColumns.find(function (vc) {
          return vc.field === columnSetting.data;
        })) {
          resultColumns.push(columnSetting);
        }
      });
      var nestedHeadersSettings = [];

      if (transformNestedHeaders.length) {
        nestedHeadersSettings = _toConsumableArray(this.hotInstance.getSettings().nestedHeaders || []);
        nestedHeadersSettings.forEach(function (cols) {
          (cols || []).forEach(function (col) {
            if (!(col && col._name)) {
              return;
            }

            var transformNestedHeader = transformNestedHeaders.find(function (h) {
              return h.nestedHeaderName === col._name;
            });

            if (!transformNestedHeader) {
              return;
            }

            col.label = transformNestedHeader.title;
          });
        });
      }

      var obj = {};

      if (transformColumns.length) {
        obj.columns = resultColumns;
        obj.colWidths = resultColumns.map(function (c) {
          return c.__width;
        });
      }

      if (transformNestedHeaders.length) {
        obj.nestedHeaders = nestedHeadersSettings;
      }

      this.hotInstance.updateSettings(obj);
    },
    getColumnSettingAtCol: function getColumnSettingAtCol(col) {
      var prop;

      if (typeof col === "string") {
        prop = col;
      } else {
        prop = this.hotInstance.colToProp(col);
      }

      if (!prop || typeof prop === "number") {
        return this.renderColumns && this.renderColumns.length > 0 ? this.renderColumns[col] : this.columnSettings[col];
      }

      var columnSettings = this.renderColumns || this.columnSettings || [];
      var columnSetting = columnSettings.find(function (c) {
        return c.data === prop;
      });
      return columnSetting;
    },
    scrollToTop: function scrollToTop() {
      return this.hotInstance.scrollViewportTo(0);
    },
    scrollToBottom: function scrollToBottom() {
      var rowCount = this.hotInstance.countRows();
      return this.hotInstance.scrollViewportTo(rowCount - 1);
    },
    setCellComment: function setCellComment(row, col, comment) {
      var plugin = this.hotInstance.getPlugin("comments");
      plugin.enablePlugin();

      var _col;

      if (typeof col === "string") {
        _col = this.hotInstance.propToCol(col);
      } else {
        _col = col;
      }

      plugin.setCommentAtCell(row, _col, comment);
    },
    removeCellComment: function removeCellComment(row, col) {
      var plugin = this.hotInstance.getPlugin("comments");
      plugin.enablePlugin();

      var _col;

      if (typeof col === "string") {
        _col = this.hotInstance.propToCol(col);
      } else {
        _col = col;
      }

      plugin.removeCommentAtCell(row, _col);
    },
    getCellComment: function getCellComment(row, col) {
      var plugin = this.hotInstance.getPlugin("comments");
      plugin.enablePlugin();

      var _col;

      if (typeof col === "string") {
        _col = this.hotInstance.propToCol(col);
      } else {
        _col = col;
      }

      return plugin.getCommentAtCell(row, _col);
    }
  },
  components: {
    GroupTableLayoutTransfer: GroupTableLayoutTransfer,
    TableLayoutTransfer: TableLayoutTransfer
  },
  mounted: function mounted() {
    this.columnSettings = this.getColumnSettings();
    this.nestedSettings = this.getNestedHeaderSettings();
    this.dynamicColumnsSettings = this.getDynamicColumnsSettings();
    return this.hotInit();
  },
  beforeDestroy: function beforeDestroy() {
    this.hotInstance.destroy();
    this.removeRefFromValidationGroup();
    this.offResizeListener && this.offResizeListener();
    this.offScrollListener && this.offScrollListener();
  },
  beforeCreate: function beforeCreate() {},
  updated: function updated() {
    var _this38 = this;

    this.$nextTick(function () {
      _this38.scrollListener(_this38.$el);
    });
  },
  destroyed: function destroyed() {
    this.destroyHandlers.forEach(function (handle) {
      handle();
    });
  },
  created: function created() {
    if (!utils.axios) {
      utils.axios = this.$axios;
    }

    if (!utils.route) {
      utils.route = this.$route;
    }

    this.getRulesByKey();
    this.addRefToValidationGroup();
  },
  version: version
};
document.addEventListener("mousedown", function (e) {
  var editorWrap = document.getElementById("vueHotComponents");

  if (!editorWrap || !editorWrap.contains(e.target)) {
    return;
  }

  Handsontable["isEditorMousdown"] = true;
}, true);
document.addEventListener("mouseup", function (e) {
  setTimeout(function () {
    Handsontable["isEditorMousdown"] = false;
  }, 0);
}, true);

/* script */
var __vue_script__$2 = HotTable;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    attrs: {
      "id": _vm.id,
      "data-code": "5ZCJ6IGU56eR5oqA"
    }
  }, [_vm._t("default"), _vm._v(" "), _c('table-layout-transfer', {
    ref: "tableLayoutTransfer"
  }), _vm._v(" "), _c('group-table-layout-transfer', {
    ref: "groupTableLayoutTransfer"
  })], 2);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-2b40d34f_0", {
    source: ".ht_master .wtHolder{background-color:#fff}.htContextMenu .ht_master .wtHolder{background-color:transparent}.ht-has-selection .ht_clone_top th:nth-child(2) .changeType,.ht-has-selection .ht_clone_top_left_corner th:nth-child(2) .changeType{display:none}.hot-layout-settings-button{margin-left:8px;border:0;background:0 0;cursor:pointer}.hot-layout-settings-button:hover{color:#00f}.hot-context-icon{margin-right:4px}.hot-context-icon-hidden{opacity:0}.handsontable td.htNoWrap{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ht-check-all{margin-left:-5px}.handsontable .caret-wrapper{position:relative;margin-left:8px}.handsontable .caret-wrapper .sort-caret{margin-left:-15px;width:0;height:0;border:solid 5px transparent;display:inline-block;position:absolute;cursor:pointer}.handsontable .caret-wrapper .sort-caret:hover{opacity:.8}.handsontable .caret-wrapper .ascending{border-bottom-color:#c0c4cc;top:-4px}.handsontable .caret-wrapper .ascending.selected{border-bottom-color:#2b579a}.handsontable .caret-wrapper .descending{border-top-color:#c0c4cc;top:10px}.handsontable .caret-wrapper .descending.selected{border-top-color:#2b579a}.handsontable .caret-wrapper sub{position:absolute;left:12px;top:8px;font-size:8px}.el-transfer-panel__item{display:block!important}.handsontable-tooltip.is-light{border:1px solid red;color:red}.handsontable-tooltip.is-light[x-placement^=bottom] .popper__arrow{border-bottom-color:red;display:inherit!important}.handsontable td.highlight,.handsontable td.ht-active-row{background-color:#cee3ff}.handsontable .sortActionDiv{cursor:pointer}.handsontable .sortActionDiv:hover .columnSorting.sortAction{text-decoration:underline;cursor:pointer}.handsontable .hotEmptyTextContainer{width:100%;height:100%;top:0;left:0;color:#999;text-align:center;position:absolute}.handsontable .hotEmptyTextContainer .hotEmptyText{position:relative;top:50%}.handsontable .hotHiddenFilter .changeType{display:none}textarea#HandsontableCopyPaste{position:fixed!important;top:0!important;right:100%!important;overflow:hidden;opacity:0;outline:0 none!important}.ht-hide-checkbox .ht-checkbox-column .htCheckboxRendererInput{display:none}.ht-hide-checkbox .ht-check-all{display:none}.table-tree-line{display:none}.ht-hide-checkbox .table-tree-line{height:100%;position:relative;overflow:hidden;display:block}.ht-hide-checkbox .table-tree-line:after{display:block;position:absolute;width:100%;height:1px;content:\"\";top:50%;border-top:1px dotted #999;left:0}.ht-column-title-text.ht-column-required::before{content:\"*\";color:red}.handsontable .columnSorting.sortAction:hover{text-decoration:none;cursor:default}.handsontable .columnSortingHover:hover{text-decoration:underline;cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject SSR */

var HotTable$1 = normalizeComponent_1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, browser, undefined);

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
     module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && ('object' !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));
});

var GROUP_RECORD_FLAG_NAME$1 = "$$groupRow";
var GROUP_RECORD_FIELD_FLAG_NAME$1 = "$$groupField";
var HotColumn = {
  name: "HotColumn",
  props: propFactory("HotColumn"),
  inject: ["$hotTable"],
  methods: {
    /**
     * Create the column settings based on the data provided to the `hot-column` component and it's child components.
     */
    createColumnSettings: function createColumnSettings() {
      var _this = this;

      var hotColumnSlots = this.$slots["default"] || [];
      var rendererVNode = findVNodeByType(hotColumnSlots, "hot-renderer");
      var editorVNode = findVNodeByType(hotColumnSlots, "hot-editor");
      var assignedProps = filterPassedProps(this.$props);

      if (rendererVNode && this.usesRendererComponent === void 0) {
        this.usesRendererComponent = true;
      }

      if (this.calculate) {
        this.$hotTable.hasCalculate = true;
      }

      this.columnSettings = _objectSpread2({}, assignedProps);

      if (!this.columnSettings.valueParser) {
        this.columnSettings.valueParser = function (value, record) {
          if (!value) return ""; // .replace(/(<br[^>]*>| |\s*)/g, '')

          var result = typeof value !== "string" ? value : value.replace(/\&/g, "&amp;").replace(/\"/g, "&quot;").replace(/\'/g, "&#39;").replace(/\</g, "&lt;").replace(/\>/g, "&gt;");
          return result;
        };
      }

      if (editorVNode && editorVNode.tag.indexOf("FrosCheckboxEditor") !== -1) {
        assignedProps["type"] = "checkbox";
        this.columnSettings.type = "checkbox";
        this.columnSettings.className = "htCenter";
        this.columnSettings.checkedTemplate = editorVNode.data.attrs.checkedTemplate ? editorVNode.data.attrs.checkedTemplate : true;
        this.columnSettings.uncheckedTemplate = editorVNode.data.attrs.uncheckedTemplate ? editorVNode.data.attrs.uncheckedTemplate : false;
        this.columnSettings.showCheckAll = editorVNode.data.attrs.showCheckAll ? editorVNode.data.attrs.showCheckAll : false;
      }

      if (assignedProps["dateFormat"]) {
        this.columnSettings.valueParser = function (value, record) {
          if (!value) return "";
          var m = "".concat(value).indexOf("T") ? moment(new Date(value)) : moment(value);
          return m.format(assignedProps["dateFormat"] === "true" ? "YYYY-MM-DD" : assignedProps["dateFormat"]);
        };
      }

      if (assignedProps["checkedDisplay"]) {
        this.columnSettings.valueParser = function (value, record) {
          if (value === assignedProps["checkedTemplate"]) {
            return assignedProps["checkedDisplay"];
          }

          return assignedProps["uncheckedDisplay"];
        };
      }

      if (rendererVNode !== null) {
        var rendererWrap = this.$hotTable.getRendererWrapper(rendererVNode, this);

        this.columnSettings.renderer = function (instance, td, row, col, prop, value, cellProperties) {
          rendererWrap(instance, td, row, col, prop, value, cellProperties);

          if (assignedProps.css && typeof assignedProps.css === "function") {
            var physicalRow = instance.toPhysicalRow(row);
            assignedProps.css({
              record: _this.$hotTable.getRecord(physicalRow),
              td: td,
              row: row,
              col: col,
              prop: prop,
              value: value
            });
          }
        };
      } else if (assignedProps.renderer) {
        this.columnSettings.renderer = assignedProps.renderer;
      } else {
        if (assignedProps["type"] !== "checkbox" && assignedProps["type"] !== "tree-checkbox" && assignedProps["type"] !== "numeric") {
          this.columnSettings.renderer = function (instance, td, row, col, prop, value, cellProperties) {
            var self = _this;
            var physicalRow = instance.toPhysicalRow(row);

            var record = _this.$hotTable.getRecord(physicalRow);

            var text = assignedProps["dictName"] && (value || value === 0) ? utils.transformDict(assignedProps["dictName"], value) : value;

            if (text == null) {
              text = "";
            }

            if (value) {
              text = _this.columnSettings.valueParser(value);
            }

            if (assignedProps["displayFormat"]) {
              text = _this.columnSettings.displayFormat({
                value: value,
                row: row,
                col: col,
                prop: prop,
                physicalRow: physicalRow,
                record: record
              });
            }

            var html = "";

            if (_this.$hotTable.groupView) {
              var groupColumns = _this.$hotTable.currentLayout ? _this.$hotTable.currentLayout["groupColumns"].map(function (column) {
                return column.field;
              }) : [];
              var nestedRowsPlugin = instance.getPlugin("nestedRows");
              var collapsingUI = nestedRowsPlugin.collapsingUI;

              if (groupColumns.includes(prop) && record && record[GROUP_RECORD_FLAG_NAME$1] && record[GROUP_RECORD_FIELD_FLAG_NAME$1] === prop) {
                html = '<span class="ht-group-expand' + (collapsingUI.areChildrenCollapsed(physicalRow) ? "" : " expanded") + '"></span> ';
              }
            }

            html += text;
            td.innerHTML = html;
            var cellMeta = instance.getCellMeta(row, col);

            if (assignedProps.css && typeof assignedProps.css === "function") {
              var _physicalRow = instance.toPhysicalRow(row);

              assignedProps.css({
                record: _this.$hotTable.getRecord(_physicalRow),
                td: td,
                row: row,
                col: col,
                prop: prop,
                value: value
              });
            }

            var classList = [];
            if (td.className) classList = td.className.split(" ");
            if (_this.columnSettings.className) classList = classList.concat(_this.columnSettings.className.split(" "));

            if (cellMeta && cellMeta.valid === false) {
              classList.push("htInvalid");

              td.onmouseover = function () {
                var tdPosition = td.getBoundingClientRect(),
                    key = row.toString() + "_" + col.toString();

                if (self.$parent.error[key]) {
                  self.$parent.showErrorMessage(tdPosition.left + document.documentElement.scrollLeft, tdPosition.top + td.clientHeight + document.documentElement.scrollTop, self.$parent.error[key]);
                }
              };

              td.onmouseout = function () {
                self.$parent.hideErrorMessage();
              };
            }

            classList.push("htNoWrap");

            switch (_this.columnSettings.align) {
              case "left":
                classList.push("htLeft");
                break;

              case "right":
                classList.push("htRight");
                break;

              case "center":
                classList.push("htCenter");
                break;

              default:
                break;
            }

            td.className = classList.join(" ");

            _this.updateTdTitle(td, text);

            return td;
          };

          if (assignedProps["dictName"]) {
            this.columnSettings.valueParser = function (value, record) {
              var v = utils.transformDict(assignedProps["dictName"], value);
              return v || "(空白单元格)";
            };
          }
        } else if (assignedProps["type"] === "numeric") {
          this.columnSettings.renderer = function (instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.NumericRenderer(instance, td, row, col, prop, value, cellProperties);

            if (assignedProps.css && typeof assignedProps.css === "function") {
              var physicalRow = instance.toPhysicalRow(row);
              assignedProps.css({
                record: _this.$hotTable.getRecord(physicalRow),
                td: td,
                row: row,
                col: col,
                prop: prop,
                value: value
              });
            }
          };
        }
      }

      if (editorVNode !== null) {
        if (this.columnSettings.type !== "checkbox") {
          var editorName = this.getEditorName(editorVNode);
          this.columnSettings.editor = this.$hotTable.getEditorClass(editorVNode, this, editorName);
          this.columnSettings.editorName = editorName;
        }
      } else if (assignedProps.editor) {
        this.columnSettings.editor = assignedProps.editor;
      }
    },
    updateTdTitle: function updateTdTitle(td, text) {
      var hasTip = this.hasTip === null ? this.$hotTable.hasTip : this.hasTip;

      if (hasTip === true || hasTip === "overflow" && td.scrollWidth > td.clientWidth) {
        td.setAttribute("title", text);
      } else {
        td.removeAttribute("title");
      }
    },
    getEditorName: function getEditorName(vNode) {
      var componentName = vNode.componentOptions.Ctor.options.name;
      var str = "";
      if (vNode.componentOptions.propsData) str += JSON.stringify(vNode.componentOptions.propsData);

      if (vNode.componentOptions.listeners) {
        for (var k in vNode.componentOptions.listeners) {
          str += vNode.componentOptions.listeners[k].toString();
        }
      }

      if (vNode.componentOptions.children) {
        str += "_children[";

        for (var c = 0; c < vNode.componentOptions.children.length; c++) {
          str += JSON.stringify(vNode.componentOptions.children[c].componentOptions.propsData || {});
        }

        str += "]";
      }

      str += "[HotTable_".concat(this.$hotTable._uid, "_HotColumn_").concat(this._uid, "]");
      componentName += this.getHashCode(str);
      return componentName;
    },
    getHashCode: function getHashCode(str) {
      var hash = 5381;

      for (var i = 0; i < str.length; i++) {
        var _char = str.charCodeAt(i);

        hash = (hash << 5) + hash + _char;
      }

      return hash.toString();
    }
  },
  render: function render() {
    return null;
  },
  mounted: function mounted() {
    this.createColumnSettings();
  },
  updated: function updated() {
    var _this2 = this;

    var hotColumnSlots = this.$slots["default"] || [];
    var editorVNode = findVNodeByType(hotColumnSlots, "hot-editor");

    if (editorVNode !== null && this.columnSettings) {
      if (this.columnSettings.type !== "checkbox") {
        var editorName = this.getEditorName(editorVNode);

        if (editorName === this.columnSettings.editorName) {
          return;
        }

        this.columnSettings.editor = this.$hotTable.getEditorClass(editorVNode, this, editorName);
        this.columnSettings.editorName = editorName;
        var columns = this.$hotTable.getColumns();
        var column = (columns || []).find(function (c) {
          return c.data === _this2.data;
        });

        if (column) {
          column.editor = this.columnSettings.editor;
          column.editorName = this.columnSettings.editorName;
          this.$hotTable.hotInstance.updateSettings({
            columns: columns
          });
        }
      }
    }
  }
};

/* script */
var __vue_script__$3 = HotColumn;
/* template */

/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = undefined;
/* style inject */

/* style inject SSR */

normalizeComponent_1({}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, undefined, undefined);

var HotNestedHeader = {
  name: 'HotNestedHeader',
  inject: ['$hotTable'],
  data: function data() {
    return {
      colspan: 0,
      nestedLevel: 0
    };
  },
  props: {
    title: {
      type: String,
      "default": ''
    },
    name: String
  }
};

/* script */
var __vue_script__$4 = HotNestedHeader;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

normalizeComponent_1({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, undefined, undefined);

var HotDynamicColumns = {
  name: 'HotDynamicColumns',
  data: function data() {
    return {};
  },
  props: {
    title: {
      type: Function,
      "default": function _default() {
        return '';
      }
    },
    data: {
      type: String,
      required: true
    }
  }
};

/* script */
var __vue_script__$5 = HotDynamicColumns;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

normalizeComponent_1({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, undefined, undefined);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

/**
  * vue-class-component v7.1.0
  * (c) 2015-present Evan You
  * @license MIT
  */

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
function copyReflectionMetadata(to, from) {
    forwardMetadata(to, from);
    Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
        forwardMetadata(to.prototype, from.prototype, key);
    });
    Object.getOwnPropertyNames(from).forEach(function (key) {
        forwardMetadata(to, from, key);
    });
}
function forwardMetadata(to, from, propertyKey) {
    var metaKeys = propertyKey
        ? Reflect.getOwnMetadataKeys(from, propertyKey)
        : Reflect.getOwnMetadataKeys(from);
    metaKeys.forEach(function (metaKey) {
        var metadata = propertyKey
            ? Reflect.getOwnMetadata(metaKey, from, propertyKey)
            : Reflect.getOwnMetadata(metaKey, from);
        if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
        }
        else {
            Reflect.defineMetadata(metaKey, metadata, to);
        }
    });
}

var fakeArray = { __proto__: [] };
var hasProto = fakeArray instanceof Array;
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== 'object' && type !== 'function');
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured',
    'serverPrefetch' // 2.6
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
                (options.methods || (options.methods = {}))[key] = descriptor.value;
            }
            else {
                // typescript decorated data
                (options.mixins || (options.mixins = [])).push({
                    data: function () {
                        var _a;
                        return _a = {}, _a[key] = descriptor.value, _a;
                    }
                });
            }
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof Vue
        ? superProto.constructor
        : Vue;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    if (reflectionIsSupported) {
        copyReflectionMetadata(Extended, Component);
    }
    return Extended;
}
var shouldIgnore = {
    prototype: true,
    arguments: true,
    callee: true,
    caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // Skip the properties that should not be overwritten
        if (shouldIgnore[key]) {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) &&
                superDescriptor &&
                superDescriptor.value === descriptor.value) {
                return;
            }
        }
        Object.defineProperty(Extended, key, descriptor);
    });
}

function Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
Component.registerHooks = function registerHooks(keys) {
    $internalHooks.push.apply($internalHooks, keys);
};

var BaseEditorComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(BaseEditorComponent, _Vue);

  function BaseEditorComponent() {
    var _this2;

    _classCallCheck(this, BaseEditorComponent);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(BaseEditorComponent).apply(this, arguments));
    _this2.name = 'BaseEditorComponent';
    _this2.instance = null;
    _this2.row = null;
    _this2.col = null;
    _this2.prop = null;
    _this2.TD = null;
    _this2.originalValue = null;
    _this2.cellProperties = null;
    _this2.state = null;
    return _this2;
  }

  _createClass(BaseEditorComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this = this;

      this.$data.hotCustomEditorClass = function () {
        var customEditorClass =
        /*#__PURE__*/
        function (_Handsontable$editors) {
          _inherits(CustomEditor, _Handsontable$editors);

          function CustomEditor(hotInstance, row, col, prop, TD, cellProperties) {
            var _this3;

            _classCallCheck(this, CustomEditor);

            _this3 = _possibleConstructorReturn(this, _getPrototypeOf(CustomEditor).call(this, hotInstance, row, col, prop, TD, cellProperties));
            _this.$data.hotCustomEditorInstance = _assertThisInitialized(_this3);
            return _this3;
          }

          _createClass(CustomEditor, [{
            key: "focus",
            value: function focus() {}
          }, {
            key: "getValue",
            value: function getValue() {}
          }, {
            key: "setValue",
            value: function setValue() {}
          }, {
            key: "open",
            value: function open() {}
          }, {
            key: "close",
            value: function close() {}
          }, {
            key: "isParentNode",
            value: function isParentNode(node, parent) {
              while (node) {
                if (node === parent) {
                  return true;
                }

                node = node.parentNode;
              }

              return false;
            }
          }]);

          return CustomEditor;
        }(Handsontable.editors.BaseEditor); // Fill with the rest of the BaseEditorComponent methods


        Object.getOwnPropertyNames(Handsontable.editors.BaseEditor.prototype).forEach(function (propName) {
          if (propName === 'constructor') {
            return;
          } // customEditorClass.prototype[propName] = function(...args) {
          //   return _this[propName].call(this, ...args);
          // };


          customEditorClass.prototype[propName] = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var allowCall = true;

            if (propName === 'prepare' || propName === 'beginEditing') {
              var currentLayoutInfo = _this['$hotTable']['getCurrentLayoutInfo']();

              var fixedColumnsLeft = _this['$hotTable']['hotSettings'].showSelection ? currentLayoutInfo.fixedColumnsLeft - 1 : currentLayoutInfo.fixedColumnsLeft;

              if (fixedColumnsLeft > 0 && args.length && args.length > 0) {
                args.map(function (value, index) {
                  if (value && value !== null && value.querySelector) {
                    if (value.getAttribute('class').indexOf('current highlight') > -1) {
                      var htCloneLeft = _this['$hotTable'].$el.querySelector('.ht_clone_left');

                      var tdClass = value.getAttribute('class').replace(/(.{0})/, '.').replace(/\s+/g, ',.');
                      var htCloneLeftArr = Array.prototype.slice.call(htCloneLeft.querySelectorAll(tdClass)); // 获取到的是nodeList,需先转成数组

                      var htCloneLeftArrClass = htCloneLeftArr.map(function (item) {
                        return item.getAttribute('class');
                      });
                      var isExitCloneLeftDom = htCloneLeftArrClass.find(function (item) {
                        return item.includes(value.getAttribute('class'));
                      });

                      if (isExitCloneLeftDom) {
                        args[index] = _this['$hotTable'].$el.querySelector('.ht_clone_left').querySelector('.current,.hightlight');
                      }
                    } else {
                      allowCall = false;
                    }
                  }
                });
              }
            }

            if (allowCall) {
              var _this$propName;

              if (args && args.length === 6 && args[3] === undefined && args[5] !== undefined && args[5].visualRow === 0) return;
              return (_this$propName = _this[propName]).call.apply(_this$propName, [this].concat(args));
            }
          };
        });
        return customEditorClass;
      }();
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      this.$el && this.$el.remove();
    } // BaseEditorComponent methods:

  }, {
    key: "_fireCallbacks",
    value: function _fireCallbacks() {
      var _Handsontable$editors2;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (_Handsontable$editors2 = Handsontable.editors.BaseEditor.prototype._fireCallbacks).call.apply(_Handsontable$editors2, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "beginEditing",
    value: function beginEditing() {
      var _Handsontable$editors3;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return (_Handsontable$editors3 = Handsontable.editors.BaseEditor.prototype.beginEditing).call.apply(_Handsontable$editors3, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "cancelChanges",
    value: function cancelChanges() {
      var _Handsontable$editors4;

      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return (_Handsontable$editors4 = Handsontable.editors.BaseEditor.prototype.cancelChanges).call.apply(_Handsontable$editors4, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "checkEditorSection",
    value: function checkEditorSection() {
      var _Handsontable$editors5;

      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return (_Handsontable$editors5 = Handsontable.editors.BaseEditor.prototype.checkEditorSection).call.apply(_Handsontable$editors5, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "close",
    value: function close() {
      var _Handsontable$editors6;

      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return (_Handsontable$editors6 = Handsontable.editors.BaseEditor.prototype.close).call.apply(_Handsontable$editors6, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "discardEditor",
    value: function discardEditor() {
      var _Handsontable$editors7;

      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return (_Handsontable$editors7 = Handsontable.editors.BaseEditor.prototype.discardEditor).call.apply(_Handsontable$editors7, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "enableFullEditMode",
    value: function enableFullEditMode() {
      var _Handsontable$editors8;

      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      return (_Handsontable$editors8 = Handsontable.editors.BaseEditor.prototype.enableFullEditMode).call.apply(_Handsontable$editors8, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "extend",
    value: function extend() {
      var _Handsontable$editors9;

      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      return (_Handsontable$editors9 = Handsontable.editors.BaseEditor.prototype.extend).call.apply(_Handsontable$editors9, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "finishEditing",
    value: function finishEditing() {
      var _Handsontable$editors10;

      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      return (_Handsontable$editors10 = Handsontable.editors.BaseEditor.prototype.finishEditing).call.apply(_Handsontable$editors10, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "focus",
    value: function focus() {
      var _Handsontable$editors11;

      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }

      return (_Handsontable$editors11 = Handsontable.editors.BaseEditor.prototype.focus).call.apply(_Handsontable$editors11, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _Handsontable$editors12;

      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }

      return (_Handsontable$editors12 = Handsontable.editors.BaseEditor.prototype.getValue).call.apply(_Handsontable$editors12, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "init",
    value: function init() {
      var _Handsontable$editors13;

      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }

      return (_Handsontable$editors13 = Handsontable.editors.BaseEditor.prototype.init).call.apply(_Handsontable$editors13, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "isInFullEditMode",
    value: function isInFullEditMode() {
      var _Handsontable$editors14;

      for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        args[_key14] = arguments[_key14];
      }

      return (_Handsontable$editors14 = Handsontable.editors.BaseEditor.prototype.isInFullEditMode).call.apply(_Handsontable$editors14, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "isOpened",
    value: function isOpened() {
      var _Handsontable$editors15;

      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        args[_key15] = arguments[_key15];
      }

      return (_Handsontable$editors15 = Handsontable.editors.BaseEditor.prototype.isOpened).call.apply(_Handsontable$editors15, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "isWaiting",
    value: function isWaiting() {
      var _Handsontable$editors16;

      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        args[_key16] = arguments[_key16];
      }

      return (_Handsontable$editors16 = Handsontable.editors.BaseEditor.prototype.isWaiting).call.apply(_Handsontable$editors16, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "open",
    value: function open() {
      var _Handsontable$editors17;

      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        args[_key17] = arguments[_key17];
      }

      return (_Handsontable$editors17 = Handsontable.editors.BaseEditor.prototype.open).call.apply(_Handsontable$editors17, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "prepare",
    value: function prepare(row, col, prop, TD, originalValue, cellProperties) {
      this.$data.hotInstance = cellProperties.instance;
      this.$data.row = row;
      this.$data.col = col;
      this.$data.prop = prop;
      this.$data.TD = TD;
      this.$data.originalValue = originalValue;
      this.$data.cellProperties = cellProperties;
      return Handsontable.editors.BaseEditor.prototype.prepare.call(this.$data.hotCustomEditorInstance, row, col, prop, TD, originalValue, cellProperties);
    }
  }, {
    key: "saveValue",
    value: function saveValue() {
      var _Handsontable$editors18;

      for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        args[_key18] = arguments[_key18];
      }

      return (_Handsontable$editors18 = Handsontable.editors.BaseEditor.prototype.saveValue).call.apply(_Handsontable$editors18, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "setValue",
    value: function setValue() {
      var _Handsontable$editors19;

      for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
        args[_key19] = arguments[_key19];
      }

      return (_Handsontable$editors19 = Handsontable.editors.BaseEditor.prototype.setValue).call.apply(_Handsontable$editors19, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "addHook",
    value: function addHook() {
      var _Handsontable$editors20;

      for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
        args[_key20] = arguments[_key20];
      }

      return (_Handsontable$editors20 = Handsontable.editors.BaseEditor.prototype.addHook).call.apply(_Handsontable$editors20, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "removeHooksByKey",
    value: function removeHooksByKey() {
      var _Handsontable$editors21;

      for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
        args[_key21] = arguments[_key21];
      }

      return (_Handsontable$editors21 = Handsontable.editors.BaseEditor.prototype.removeHooksByKey).call.apply(_Handsontable$editors21, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }, {
    key: "clearHooks",
    value: function clearHooks() {
      var _Handsontable$editors22;

      for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
        args[_key22] = arguments[_key22];
      }

      return (_Handsontable$editors22 = Handsontable.editors.BaseEditor.prototype.clearHooks).call.apply(_Handsontable$editors22, [this.$data.hotCustomEditorInstance].concat(args));
    }
  }]);

  return BaseEditorComponent;
}(Vue);

BaseEditorComponent = __decorate([Component({
  inject: ['$hotTable']
})], BaseEditorComponent);
var script$2 = BaseEditorComponent;

/* script */
var __vue_script__$6 = script$2;
/* template */

/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = undefined;
/* style inject */

/* style inject SSR */

normalizeComponent_1({}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, undefined, undefined);

export default HotTable$1;
export { BaseEditorComponent, HotColumn, HotDynamicColumns, HotNestedHeader, HotTable, utils };
